import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';

import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import NovoDocumentoPopup from '@/components/documentos/NovoDocumentoPopup/NovoDocumentoPopup.vue';
import NovoDependentePopup from '@/components/NovoDependentePopup/NovoDependentePopup.vue';
import NovoVTPopup from '@/components/NovoVTPopup/NovoVTPopup.vue';
import NovaFormacaoPopup from '@/components/NovaFormacaoPopup/NovaFormacaoPopup.vue';
import NovoBeneficioPopup from '@/components/NovoBeneficioPopup/NovoBeneficioPopup.vue';
import orgaosExpedidoresRG from '@/assets/json/static-data/orgaos_expedidores_rg.json';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import AdmissaoController from '@/assets/ts/controller/AdmissaoController';
import VinculoController from '@/assets/ts/controller/VinculoController';
import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import EditableTableColumn from '@/../bower_components/teknisavuecomponents/assets/interfaces/EditableTableColumn';
import Action from '@/../bower_components/teknisavuecomponents/assets/interfaces/Action';
import ToolbarAction from '@/../bower_components/teknisavuecomponents/assets/interfaces/ToolbarAction';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import ExpectedError from '@/../bower_components/teknisavuecomponents/assets/utils/ExpectedError';
import DocumentoUtil from '@/assets/ts/utils/DocumentoUtil';
import NovaSolicitacaoController from '@/assets/ts/controller/NovaSolicitacaoController';
import store from '@/store/store';
import User from '@/../bower_components/teknisavuecomponents/assets/interfaces/User';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';
import DialogUtils from '@/../bower_components/teknisavuecomponents/assets/utils/DialogUtils';
import Messages from '@/assets/ts/utils/Messages';
import { SolicitacaoController, TiposSolicitacao } from '@/assets/ts/controller/SolicitacaoController';
import { isBefore, isSameDay, parse } from 'date-fns';
import { DadosVinculo } from '@/assets/ts/interfaces/Admissao';
import EscalaController from '@/assets/ts/controller/EscalaController';

@Component({
  name: 'NovaAdmissaoPopup',
  components: {
    TkForm,
    EditableTable,
    NovoDocumentoPopup,
    NovoDependentePopup,
    NovoVTPopup,
    NovaFormacaoPopup,
    NovoBeneficioPopup,
  },
})
class NovaAdmissaoPopup extends Vue {
  // #region [ PROPS ]
  @Prop({ default: 'edit' })
  private readonly mode: string;

  @Prop({ default: () => {} })
  private readonly row: any;

  @Prop({ default: 'simplificada' })
  private readonly tipoAdmissao: string;

  @Prop({ default: false })
  private readonly value: boolean;
  // #endregion

  // #region [STORE]
  private get user(): User {
    return store.getters.user;
  }

  private get estruturaGerencialAtual(): Estrutura {
    return store.getters.estruturaGerencialAtual;
  }
  // #endregion

  // #region [ EVENTS ]
  @Emit('after-save')
  private emitAfterSave() {}

  @Emit('input')
  private emitInput(value: boolean) {}
  // #endregion

  // #region [ DATA ]
  private tkForm: any = {
    row: {},
    loading: false,
  };

  private internalValue = false;

  private loaded = false;

  private dialogHeight = 500;

  private cpfDados = null;

  private vinculoCpf = null;

  private isSalarioReadOnly = false;
  private isSoliSubstituicao = false;

  private isEscala12x36 = false;
  private comOperador = false;

  private rowsDadosPessoais = {
    pessoa: {} as any,
    operador: {} as any,
    documentos: {} as any,
    docProf: {} as any,
    complementares: {} as any,
    conselho: {} as any,
    militar: {} as any,
    filiacao: {} as any,
  };

  private rowsDadosVinculo = {
    vinculo: {} as any,
    ocupacao: {} as any,
    escala: {} as any,
    empresa: {} as any,
    salario: {} as any,
  };

  private rowsFormacao: any[] = [];
  private rowEndereco: any = {};
  private rowConta: any = {};
  private rowComunicacao: any = {};
  private rowsDocumentos: any[] = [];
  private rowsDependentes: any[] = [];
  private rowsValeTransporte: any[] = [];
  private rowsBeneficios: any[] = [];
  private solicitacoesAdmissao: any[] = [];

  private readonly defaultRowEndereco = {
    CDPAIS: '0055',
    SGESTADO: null,
    CDMUNICIPIO: null,
    NMBAIRROENDERECO: null,
    DSENDERECO: null,
    CDLOGRADOURO: null,
    CDTIPOENDERECO: 'PRINCIPAL',
  };

  private readonly defaultRowDadosPessoaisPessoa = {
    CDPAISNATURALI: '0055',
    SGESTADONATURALI: null,
    CDMUNICIPIONATURALI: null,
    IDCOTAPCD: 'N',
    IDISENTITUELEI: 'N',
    IDPESNATURALIZA: 'N',
    IDPOSVISTOPERM: 'N',
    NRNACIONALID: '1',
  };

  private readonly defaultRowDadosPessoaisOperador = {
    IDATIVO: 'S'
  }

  private readonly defaultRowConta = {
    CDBANCO: null,
    CDAGENCIA: null,
  };

  private readonly defaultRowDadosVinculo = {
    IDCONTRIBUISIND: 'NUNCA',
    IDREMUNERACAO: 'SAL1',
    IDTPPAGAMENTO: 'MENSAL',
    IDMULTVINC: 'UNICO',
  };

  private readonly defaultRowDadosVinculoSalario = {
    NRTPMODALIDSAL: '1',
    NROCORRENCIA: '1',
  };

  private readonly defaultRowDadosVinculoOcupacao = {
    NRTIPOOCUPACAO: '1',
  };

  private defaultRowDadosVinculoEscala = {
    NRESCALATRABM: null,
    NRTURNO: null,
  };

  private defaultRowDadosVinculoEmpresa = {
    NRESTRUTLEGAL: null,
    NRESTRUTGEREN: null, // será definido na função getDefaultRowEmpresa
  };

  private generalFieldsData = {
    paises: [] as any[],
    estadosBR: [] as any[],
  };

  private dadosPessoaisFieldsData = {
    estadosCivis: [] as any[],
    condicoesFisicas: [] as any[],
    racas: [] as any[],
    grausInstrucao: [] as any[],
    estados: [] as any[],
    municipios: [] as any[],
    nacionalidades: [] as any[],
    orgaosRG: orgaosExpedidoresRG,
    classificacoesEstrangeiro: [] as any[],
    conselhos: [] as any[],
    categoriasMilitares: [] as any[],
  };

  private dadosVinculosFieldsData = {
    tiposVinculo: [] as any[],
    tiposAdmissao: [] as any[],
    vinculosEmpregaticios: [] as any[],
    cargos: [] as any[],
    tiposOcupacao: [] as any[],
    escalas: [] as any[],
    turnos: [] as any[],
    estruturasGerenciais: [] as any[],
    estruturasLegais: [] as any[],
    estruturasSindicais: [] as any[],
    estruturasAdicionais: [] as any[],
    tiposSalario: [] as any[],
    modalidadesSalario: [] as any[],
    vinculos: [] as any[],
    motivosAdmissao: [] as any[],
    tipoTransferencia: [] as any[],
  };

  private enderecoFieldsData = {
    tiposEndereco: [] as any[],
    estados: [] as any[],
    municipios: [] as any[],
    logradouros: [] as any[],
  };

  private contaFieldsData = {
    bancos: [] as any[],
    tiposConta: [] as any[],
    agencias: [] as any[],
  };


  private comunicacaoFields = [
    {
      name: 'PREFTELPRINCIPAL',
      label: 'Prefixo',
      size: 2,
      type: 'text',
    },
    {
      name: 'TELPRINCIPAL',
      label: 'Telefone Principal',
      size: 3,
      type: 'text',
    },
    {
      size: 2,
      type: 'empty',
    },
    {
      name: 'PREFTELRESIDEN',
      label: 'Prefixo',
      size: 2,
      type: 'text',
    },
    {
      name: 'TELRESIDEN',
      label: 'Telefone Residencial',
      size: 3,
      type: 'text',
    },
    {
      name: 'PREFTELCOMERC',
      label: 'Prefixo',
      size: 2,
      type: 'text',
    },
    {
      name: 'TELCOMERC',
      label: 'Telefone Comercial',
      size: 3,
      type: 'text',
    },
    {
      size: 2,
      type: 'empty',
    },
    {
      name: 'PREFCELPARTIC',
      label: 'Prefixo',
      size: 2,
      type: 'text',
    },
    {
      name: 'CELPARTIC',
      label: 'Celular Particular',
      size: 3,
      type: 'text',
    },
    {
      name: 'PREFCELCOMERC',
      label: 'Prefixo',
      size: 2,
      type: 'text',
    },
    {
      name: 'CELCOMERC',
      label: 'Celular Comercial',
      size: 3,
      type: 'text',
    },
    {
      size: 2,
      type: 'empty',
    },
    {
      name: 'PREFFAX',
      label: 'Prefixo',
      size: 2,
      type: 'text',
    },
    {
      name: 'FAX',
      label: 'Fax',
      size: 3,
      type: 'text',
    },
    {
      name: 'EMAIL',
      label: 'E-mail',
      size: 6,
      type: 'text',
    },
  ];

  private showDocumentoPopup = false;

  private documentosGrid = {
    showPopup: false,
    currentRow: null,
    toolbarActions: [
      {
        name: 'addDoc',
        label: 'Adicionar',
        icon: 'mdi-plus-circle',
        onClick: this.addDocumento,
      },
    ] as ToolbarAction[],
    actions: [
      {
        name: 'popupEdit',
        label: 'Editar',
        icon: 'mdi-pencil',
        mode: 'view',
        onClick: this.editDocumento,
      },
      'delete',
    ] as (Action | string)[],
    columns: [
      {
        value: 'NMANEXO',
        text: 'Nome',
        type: 'text',
      },
      {
        value: 'DSREFERENCIA',
        text: 'Referência',
        type: 'text',
      },
      {
        value: 'NMCATEGDOCUMENTO',
        text: 'Categoria',
        type: 'text',
      },
      {
        value: 'NMTIPODOCUMENTO',
        text: 'Tipo',
        type: 'text',
      },
    ] as EditableTableColumn[],
  };

  private dependentesGrid = {
    showPopup: false,
    currentId: 0,
    currentRow: null,
    toolbarActions: [
      {
        name: 'addDep',
        label: 'Adicionar',
        icon: 'mdi-plus-circle',
        onClick: this.addDep,
      },
    ] as ToolbarAction[],
    actions: [
      {
        name: 'popupEdit',
        label: 'Editar',
        icon: 'mdi-pencil',
        mode: 'view',
        onClick: this.editDep,
      },
      'delete',
    ] as (Action | string)[],
    columns: [
      {
        value: 'NMPESSOA',
        text: 'Nome',
        type: 'text',
      },
      {
        value: 'DSSEXOPESSOA',
        text: 'Sexo',
        type: 'text',
      },
      {
        value: 'NMTIPORELACIONA',
        text: 'Tipo de Relacionamento',
        type: 'text',
      },
      // {
      //   value: '__aviso',
      //   text: '',
      //   type: 'icon',
      //   tooltip: this.getDependenteTooltip,
      //   icon: this.getDependenteIcon,
      //   color: 'error',
      //   align: 'center',
      // },
    ] as EditableTableColumn[],
    onUpdate: (rows: any[]) => {
      this.rowsDependentes = rows;
    }
  };

  private vtGrid = {
    showPopup: false,
    currentRow: null,
    toolbarActions: [
      {
        name: 'addVT',
        label: 'Adicionar',
        icon: 'mdi-plus-circle',
        onClick: this.addVT,
      },
    ] as ToolbarAction[],
    actions: [
      {
        name: 'popupEdit',
        label: 'Editar',
        icon: 'mdi-pencil',
        mode: 'view',
        onClick: this.editVT,
      },
      'delete',
    ] as (Action | string)[],
    columns: [
      {
        value: 'DSLINHATRANSP',
        text: 'Linha',
        type: 'text',
      },
      {
        value: 'VRTARIFA',
        text: 'Valor da Tarifa',
        type: 'text',
      },
      {
        value: 'CDINTEGRACAO',
        text: 'Integração',
        type: 'text',
      },
      {
        value: 'DSTIPOLINHAVINC',
        text: 'Tipo de Linha',
        type: 'text',
      },
      {
        value: 'QTLINHATARIFA',
        text: 'Quantidade',
        type: 'text',
      },
      {
        value: 'DTINILINHAVINC',
        text: 'Início de Validade',
        type: 'text',
      },
      {
        value: 'DTFIMLINHAVINC',
        text: 'Fim de Validade',
        type: 'text',
      },
    ] as EditableTableColumn[],
  };

  private formacaoGrid = {
    showPopup: false,
    currentRow: null,
    toolbarActions: [
      {
        name: 'addFormacao',
        label: 'Adicionar',
        icon: 'mdi-plus-circle',
        onClick: this.addFormacao,
      },
    ] as ToolbarAction[],
    actions: [
      {
        name: 'popupEdit',
        label: 'Editar',
        icon: 'mdi-pencil',
        mode: 'view',
        onClick: this.editFormacao,
      },
      'delete',
    ] as (Action | string)[],
    columns: [
      {
        value: 'DSTIPOFORMACAO',
        text: 'Tipo de Formação',
        type: 'text',
      },
      {
        value: 'NMCURSO',
        text: 'Curso',
        type: 'text',
      },
      {
        value: 'NMINSTITUICAOPARC',
        text: 'Instituição Estrutura',
        type: 'text',
      },
    ] as EditableTableColumn[],
  };

  private beneficioGrid = {
    showPopup: false,
    currentRow: null,
    toolbarActions: [
      {
        name: 'addBeneficio',
        label: 'Adicionar',
        icon: 'mdi-plus-circle',
        onClick: this.addBeneficio,
      },
    ] as ToolbarAction[],
    actions: [
      {
        name: 'popupEdit',
        label: 'Editar',
        icon: 'mdi-pencil',
        mode: 'view',
        onClick: this.editBeneficio,
      },
      'delete',
    ] as (Action | string)[],
    columns: [
      {
        value: 'NRBENEFICIOM',
        text: 'Código do Benefício',
        type: 'text',
      },
      {
        value: 'DSBENEFICIO',
        text: 'Descrição',
        type: 'text',
      },
      {
        value: 'DTINSCBENEFICIARIO',
        text: 'Data de Inscrição',
        type: 'text',
      },
    ] as EditableTableColumn[],
  };

  private readonly defaultMainPanelsExpansion = [0, 1];
  private readonly defaultDadosPessoaisPanelsExpansion = [0, 1, 2];
  private readonly defaultDadosVinculoPanelsExpansion = [0];

  private mainPanelsExpansion = [];
  private dadosPessoaisPanelsExpansion = [];
  private dadosVinculoPanelsExpansion = [];

  private dataIsLoaded = false;
  private dadosPessoaisFormMode = 'edit';
  private enderecoFormMode = 'edit';
  private contaCorrenteFormMode = 'edit';
  private comunicacaoFormMode = 'edit';
  // #endregion

  // #region [ COMPUTED ]
  private get cardTitle(): string {
    const title = this.completa ?
      'Admissão Completa' :
      'Admissão Simplificada';

    return title;
  }

  /* DADOS PESSOAIS FIELDS */
  private get pessoaFields(): Field[] {
    const fields = [
      {
        name: 'DSPRONOMETRAT',
        label: 'Tratamento',
        type: 'select',
        size: 3,
        items: [
          'Sr.',
          'Sra.',
          'Srta.',
          'Dr.',
        ],
      },
      {
        name: 'NMPESSOA',
        label: 'Nome',
        type: 'text',
        size: 6,
        required: true,
      },
      {
        name: 'DSAPELIDOPESS',
        label: 'Nome Social',
        type: 'text',
        size: 3,
      },
      {
        name: 'DTNASCPESSOA',
        label: 'Data de Nascimento',
        type: 'date',
        size: 4,
        required: true,
      },
      {
        name: 'IDSEXOPESSOA',
        label: 'Sexo',
        type: 'select',
        size: 4,
        items: [
          {
            name: 'M',
            label: 'Maculino',
          },
          {
            name: 'F',
            label: 'Feminino',
          },
        ],
        descriptionField: 'label',
        valueField: 'name',
        required: this.completa,
      },
      {
        name: 'CDESTACIVIL',
        label: 'Estado Civil',
        type: 'select',
        size: 4,
        required: this.completa,
        descriptionField: 'NMESTACIVIL',
        valueField: 'CDESTACIVIL',
        items: this.dadosPessoaisFieldsData.estadosCivis,
      },
      {
        name: 'IDGRUPSANGUPES',
        label: 'Grupo Sanguíneo',
        hideEmptyValue: false,
        size: 3,
        descriptionField: 'DS',
        valueField: 'IDGRUPSANGUPES',
        type: 'select',
        items: [
            {
              IDGRUPSANGUPES: 'A',
              DS: 'A',
            },
            {
              IDGRUPSANGUPES: 'B',
              DS: 'B',
            },
            {
              IDGRUPSANGUPES: 'AB',
              DS: 'AB',
            },
            {
              IDGRUPSANGUPES: 'O',
              DS: 'O',
            },
        ],
      },
      {
        name: 'IDFATORRHPES',
        label: 'Fator RH',
        hideEmptyValue: false,
        size: 2,
        descriptionField: 'DS',
        valueField: 'IDFATORRHPES',
        type: 'select',
        items: [
            {
                IDFATORRHPES: 'P',
                DS: 'Positivo',
            },
            {
                IDFATORRHPES: 'N',
                DS: 'Negativo',
            },
            {
                IDFATORRHPES: 'I',
                DS: 'Indefinido',
            },
        ],
      },
      {
        name: 'NRCONDFISPES',
        label: 'Condição Física',
        size: 4,
        descriptionField: 'DSCONDFISPES',
        valueField: 'NRCONDFISPES',
        type: 'autocomplete',
        items: this.dadosPessoaisFieldsData.condicoesFisicas,
      },
      {
        name: 'IDCOTAPCD',
        label: 'Cota PCD',
        size: 3,
        type: 'checkbox',
        valueToTrue: 'S',
        valueToFalse: 'N',
      },
      {
        name: 'NRRACAPESSOA',
        label: 'Raça',
        size: 3,
        type: 'autocomplete',
        valueField: 'NRRACAPESSOA',
        descriptionField: 'NMRACAPESSOA',
        items: this.dadosPessoaisFieldsData.racas,
        required: this.completa,
      },
      {
        name: 'NRGRAUINSTR',
        label: 'Grau de Instrução',
        size: 9,
        type: 'autocomplete',
        valueField: 'NRGRAUINSTR',
        descriptionField: 'NMGRAUINSTR',
        items: this.dadosPessoaisFieldsData.grausInstrucao,
      },
      {
        name: 'CDPAISNATURALI',
        label: 'País',
        size: 4,
        hideEmptyValue: false,
        type: 'autocomplete',
        valueField: 'CDPAIS',
        descriptionField: 'NMPAIS',
        items: this.generalFieldsData.paises,
        required: this.completa,
      },
      {
        name: 'SGESTADONATURALI',
        label: 'Estado',
        size: 4,
        type: 'autocomplete',
        descriptionField: 'NMESTADO',
        valueField: 'SGESTADO',
        items: this.dadosPessoaisFieldsData.estados,
        readonly: !this.rowsDadosPessoais.pessoa.CDPAISNATURALI
      },
      {
        name: 'CDMUNICIPIONATURALI',
        label: 'Município',
        size: 4,
        type: 'autocomplete',
        valueField: 'CDMUNICIPIO',
        descriptionField: 'NMMUNICIPIO',
        items: this.dadosPessoaisFieldsData.municipios,
        readonly: !this.rowsDadosPessoais.pessoa.CDPAISNATURALI || !this.rowsDadosPessoais.pessoa.SGESTADONATURALI,
      },
      {
        name: 'NRNACIONALID',
        label: 'Nacionalidade',
        size: 4,
        type: 'autocomplete',
        required: this.completa,
        hideEmptyValue: true,
        valueField: 'NRNACIONALIDADE',
        descriptionField: 'DSNACIONALIDADE',
        items: this.dadosPessoaisFieldsData.nacionalidades,
      },
      {
        name: 'INSERE_OPERADOR',
        label: 'Criar Operador',
        size: 4,
        type: 'checkbox',
        valueToTrue: 'S',
        valueToFalse: 'N',
        onInput: this.comEmailOperadorOnInput,
      },
      {
        name: 'EMAIL',
        label: 'Email do Operador',
        type: 'text',
        size: 4,
        required: this.comOperador
      },
      {
        name: 'DTADMISSAOPRE',
        label: 'Dt. Admissão Preliminar',
        size: 4,
        type: 'date',
        isVisible: false,
      },
      {
        name: 'CDRECIBOADMPRE',
        label: 'Nº Recibo Admissão Preliminar',
        size: 4,
        type: 'text',
        isVisible: false,
      }
    ];

    return fields;
  }

  private get documentosFields(): Field[] {
    const fields = [
      {
        name: 'NRSOLICITACAO',
        label: 'Solicitação de admissão',
        size: 3,
        type: 'autocomplete',
        valueField: 'NRSOLICITACAO',
        descriptionField: 'NRNMSOLICITACAO',
        items: this.solicitacoesAdmissao,
        onInput: this.solicitacaoOnInput,
        forceNotReadOnly: true,
        required: this.user.nrorg == '1410',
      },
      {
        name: 'NRCPFPESSOA',
        label: 'CPF',
        size: 3,
        type: 'text',
        required: true,
        mask: '###.###.###-##',
        forceNotReadOnly: true,
        onInput: this.onCpfInput
      },
      {
        name: 'NRRGPESSOA',
        label: 'RG',
        size: 3,
        type: 'text',
        required: this.completa,
      },
      {
        name: 'CDEXRGPESSOA',
        label: 'Órgão Expedidor RG',
        size: 3,
        required: this.completa,
        descriptionField: 'NMEXRGPESSOA',
        valueField: 'CDEXRGPESSOA',
        type: 'autocomplete',
        items: orgaosExpedidoresRG,
      },
      {
        name: 'DTEXRGPESSOA',
        label: 'Dt. Expedição RG',
        size: 4,
        type: 'date',
        required: this.completa,
      },
      {
        name: 'DSLOCALEXRGPES',
        label: 'Local de Expedição',
        size: 4,
        type: 'text',
      },
      {
        name: 'SGUFRGPESSOA',
        label: 'UF-RG',
        size: 4,
        type: 'autocomplete',
        required: this.completa,
        valueField: 'SGESTADO',
        descriptionField: 'NMESTADO',
        items: this.generalFieldsData.estadosBR,
      },
      {
        name: 'NRSUSPESSOA',
        label: 'Nr. Cartão SUS',
        size: 6,
        type: 'number',
      },
      {
        name: 'NRNITPESSOA',
        label: 'NIT',
        size: 6,
        type: 'number',
      },
      {
        name: 'NRTITUELEIPES',
        label: 'Título de Eleitor',
        size: 4,
        'fieldGroup': 'DOCUMENTOS',
        type: 'text',
      },
      {
        name: 'NRZONAELEIPES',
        label: 'Zona',
        size: 2,
        type: 'text',
      },
      {
        name: 'NRSECAELEIPES',
        label: 'Seção',
        size: 2,
        type: 'text',
      },
      {
        name: 'IDISENTITUELEI',
        label: 'Isento Título Eleitoral',
        size: 4,
        type: 'checkbox',
        valueToTrue: 'S',
        valueToFalse: 'N',
      },
      {
        name: 'NRCERTNASCPES',
        label: 'Certidão Nascimento',
        size: 6,
        type: 'text',
      },
      {
        name: 'NRLIVROCERTNASC',
        label: 'Livro',
        size: 3,
        type: 'number',
      },
      {
        name: 'NRFOLHACERTNASC',
        label: 'Folha',
        size: 3,
        type: 'number',
      },
      {
        name: 'DSCOMPLCERTNASC',
        label: 'Complemento Certidão Nasc.',
        size: 6,
        type: 'text',
      },
      {
        name: 'NRCERTOBITO',
        label: 'Nr. Certificado de Óbito',
        size: 6,
        type: 'text',
      },
      {
        name: 'NRCERTCASAPES',
        label: 'Certidão Casamento',
        size: 8,
        type: 'text',
      },
      {
        name: 'DTCASAPESSOA',
        label: 'Dt. Casamento',
        size: 4,
        type: 'date',
      },
      {
        name: 'NRCARTHABPES',
        label: 'CNH',
        size: 4,
        type: 'text',
      },
      {
        name: 'DTHABCARTPES',
        label: 'Dt. Habilitação',
        size: 4,
        type: 'date',
      },
      {
        name: 'DSCATEGHABCART',
        label: 'Categoria CNH',
        size: 4,
        type: 'text',
      },
      {
        name: 'DTVALHABCARTPES',
        label: 'Validade CNH',
        size: 4,
        type: 'date',
      },
      {
        name: 'SGUFHABCARPES',
        label: 'UF CNH',
        size: 4,
        type: 'autocomplete',
        hideEmptyValue: true,
        valueField: 'SGESTADO',
        descriptionField: 'NMESTADO',
        items: this.generalFieldsData.estadosBR,
      },
    ];

    return fields;
  }

  private get docProfFields(): Field[] {
    const fields = [
      {
        name: 'NRCTPSPESSOA',
        label: 'Nr. CTPS',
        size: 3,
        type: 'text',
        required: this.completa,
      },
      {
        name: 'NRSERIECTPSPES',
        label: 'Série CTPS',
        size: 3,
        type: 'text',
        required: this.completa,
      },
      {
        name: 'SGUFCTPSPES',
        label: 'UF do CTPS',
        size: 6,
        type: 'autocomplete',
        required: this.completa,
        valueField: 'SGESTADO',
        descriptionField: 'NMESTADO',
        items: this.generalFieldsData.estadosBR,
      },
      {
        name: 'DTCTPSPESSOA',
        label: 'Dt. Emissão CTPS',
        size: 4,
        type: 'date',
        required: this.completa,
      },
      {
        name: 'NRPISPASEPPES',
        label: 'Nr. PIS/PASEP',
        size: 4,
        type: 'text',
        required: this.completa,
        onInput: this.validarPIS,
      },
      {
        name: 'DTINSCPISPASEP',
        label: 'Dt. PIS/PASEP',
        size: 4,
        type: 'date',
      },
      {
        name: 'NRINSCINSSPES',
        label: 'INSS',
        size: 4,
        type: 'text',
      },
      {
        name: 'NRINSCISSPES',
        label: 'ISS',
        size: 4,
        type: 'text',
      },
      {
        name: 'NRREGCTPSPES',
        label: 'Registro Profissional MTE',
        size: 4,
        type: 'text',
      },
    ];

    return fields;
  }

  private get complementaresFields(): Field[] {
    const fields = [
      {
        name: 'DSEXPDOCESTR',
        label: 'Órgão Emissor da RNE',
        size: 6,
        type: 'text'
      },
      {
        name: 'NRCLASSESTRANG',
        label: 'Classificação Trabalhador Estrangeiro',
        size: 6,
        hideEmptyValue: false,
        type: 'autocomplete',
        valueField: 'NRCLASSESTRANG',
        descriptionField: 'DSCLASSESTRANG',
        items: this.dadosPessoaisFieldsData.classificacoesEstrangeiro,
      },
      {
        name: 'DTCHEGADAPAIS',
        label: 'Dt. Chegada',
        size: 6,
        type: 'date'
      },
      {
        name: 'NRDOCUESTRANG',
        label: 'Doc. Estrangeiro',
        size: 6,
        type: 'text'
      },
      {
        name: 'IDPESNATURALIZA',
        label: 'Naturalizado',
        size: 6,
        type: 'checkbox',
        valueToTrue: 'S',
        valueToFalse: 'N',
      },
      {
        name: 'DTNATURALIZAPES',
        label: 'Dt. Naturalidade',
        size: 6,
        type: 'date'
      },
      {
        name: 'IDPOSVISTOPERM',
        label: 'Visto Permanente',
        size: 6,
        type: 'checkbox',
        valueToTrue: 'S',
        valueToFalse: 'N',
      },
      {
        name: 'DTPERMAVISTO',
        label: 'Dt. Permanência',
        size: 6,
        type: 'date'
      },
    ];

    return fields;
  }

  private get conselhoFields(): Field[] {
    const fields = [
      {
        name: 'NRCONSELHOREG',
        label: 'Conselho Regional',
        size: 6,
        descriptionField: 'NMCONSELHOREG',
        valueField: 'NRCONSELHOREG',
        type: 'autocomplete',
        items: this.dadosPessoaisFieldsData.conselhos,
      },
      {
        name: 'NRINSCRCONSREG',
        label: 'Inscrição no Conselho',
        size: 6,
        type: 'text',
      },
      {
        name: 'DTEXCONSREG',
        label: 'Dt. Ex. Conselho',
        size: 6,
        type: 'date',
      },
      {
        name: 'SGUFCONSREG',
        label: 'UF Conselho',
        size: 6,
        type: 'autocomplete',
        valueField: 'SGESTADO',
        descriptionField: 'NMESTADO',
        items: this.generalFieldsData.estadosBR,
      },
      {
        name: 'DTINIVIGENCIA',
        label: 'Início Vigência',
        size: 6,
        type: 'date',
      },
      {
        name: 'DTFIMVIGENCIA',
        label: 'Fim Vigência',
        size: 6,
        type: 'date',
      },
    ];

    return fields;
  }

  private get militarFields(): Field[] {
    const fields = [
      {
        name: 'NRCATMILITARPE',
        label: 'Categoria Militar',
        size: 6,
        descriptionField: 'NMCATMILITARPE',
        valueField: 'NRCATMILITARPE',
        type: 'autocomplete',
        items: this.dadosPessoaisFieldsData.categoriasMilitares,
      },
      {
        name: 'NRCERTRESEPES',
        label: 'Certificado de Reservista',
        size: 6,
        type: 'text'
      },
      {
        name: 'CDEXCERTRESEPES',
        label: 'Cd. Expedição',
        size: 4,
        type: 'text'
      },
      {
        name: 'DSCATEGCERTRESE',
        label: 'Categ. Certificado',
        size: 4,
        type: 'text'
      },
      {
        name: 'DTCERTRESEPES',
        label: 'Dt. Certificado de Reservista',
        size: 4,
        type: 'date'
      },
    ];

    return fields;
  }

  private get filiacaoFields(): Field[] {
    const fields = [
      {
        name: 'NMPAI',
        label: 'Nome do Pai',
        type: 'text',
        size: 6,
        onInput: this.paiOnInput,
      },
      {
        name: 'NMMAE',
        label: 'Nome da Mãe',
        type: 'text',
        size: 6,
        required: this.completa,
        onInput: this.maeOnInput,
      },
    ];

    return fields;
  };
  /* FIM DADOS PESSOAIS */

  /* DADOS VÍNCULO FIELDS */
  private get vinculoFields(): Field[] {
    const fields: Field[] = [
      {
        name: 'NRTIPOVINCULOM',
        label: 'Tipo de Vínculo',
        type: 'autocomplete',
        size: 6,
        required: true,
        descriptionField: 'NMTIPOVINCULOH',
        valueField: 'NRTIPOVINCULOM',
        items: this.dadosVinculosFieldsData.tiposVinculo,
      },
      {
        name: 'IDMULTVINC',
        label: 'Múltiplos Vínculos',
        type: 'autocomplete',
        size: 6,
        required: true,
        descriptionField: 'DS',
        valueField: 'IDMULTVINC',
        items: [
          {
            IDMULTVINC: "UNICO",
            DS: "Único"
          },
          {
            IDMULTVINC: "PRIMARIO",
            DS: "Primário"
          },
          {
            IDMULTVINC: "SECUNDARIO",
            DS: "Secundário"
          }
        ],
      },
      {
        name: 'DTADMISSAOVINC',
        label: 'Data de Admissão',
        type: 'date',
        size: 3,
        required: true,
        onInput: this.dtAdmissaoOnInput,
      },
      {
        name: 'DTEXAMEMEDICO',
        label: 'Dt. Exame Médico',
        type: 'date',
        size: 3,
        required: this.completa,
      },
      {
        name: 'NRTPADMISSAO',
        label: 'Tipo de Admissão',
        type: 'autocomplete',
        size: 6,
        required: this.completa,
        descriptionField: 'NMTPADMISSAO',
        valueField: 'NRTPADMISSAO',
        items: this.dadosVinculosFieldsData.tiposAdmissao,
      },
      {
        name: 'NRVINCULOEMPREG',
        label: 'Vínculo Empregatício',
        type: 'autocomplete',
        size: 6,
        required: true,
        descriptionField: 'NMABREV',
        valueField: 'NRVINCULOEMPREG',
        items: this.dadosVinculosFieldsData.vinculosEmpregaticios,
      },
      {
        name: 'NRMOTIVOADMISSAO',
        label: 'Motivo da Admissão',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMMOTIVOADMISSAO',
        valueField: 'NRMOTIVOADMISSAO',
        items: this.dadosVinculosFieldsData.motivosAdmissao,
        onInput: this.motivoAdmissaoOnInput,
        readonly: this.isSoliSubstituicao,
      },
      {
        name: 'NRVINCULOMSUBST',
        label: 'Vínculo Substituído',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'DSVINCULOM',
        valueField: 'NRVINCULOM',
        items: this.dadosVinculosFieldsData.vinculos,
        readonly: Util.isUndefinedOrNull(this.rowsDadosVinculo.vinculo.NRMOTIVOADMISSAO) || this.isSoliSubstituicao,
        onInput: this.verificaSolicitacaoSubstituicaoVinculo,
      },
      {
        name: 'DTBASEFERIAS',
        label: 'Dt. Base Férias',
        type: 'date',
        size: 3,
      },
      {
        name: 'CDMATRICULA',
        label: 'Matricula',
        type: 'text',
        size: 3,
      },
      {
        name: 'IDREMUNERACAO',
        label: 'Tipo de Remuneração',
        type: 'autocomplete',
        size: 4,
        required: true,
        descriptionField: 'DS',
        valueField: 'IDREMUNERACAO',
        items: [
          {
            IDREMUNERACAO: 'SAL1',
            DS: 'Salário Mensal',
          },
          {
            IDREMUNERACAO: 'SAL1_RSR',
            DS: 'Salário Mensal RSR',
          },
          {
            IDREMUNERACAO: 'SAL2',
            DS: 'Salário Hora',
          },
          {
            IDREMUNERACAO: 'SAL2_RSR',
            DS: 'Salário Hora RSR',
          },
          {
            IDREMUNERACAO: 'ESTAGIO',
            DS: 'Estágio',
          },
          {
            IDREMUNERACAO: 'SOCIO',
            DS: 'Sócio',
          },
          {
            IDREMUNERACAO: 'AUTONOMO',
            DS: 'Autônomo',
          },
          {
            IDREMUNERACAO: 'NENHUM',
            DS: 'Nenhum',
          },
        ],
      },
      {
        name: 'IDTPPAGAMENTO',
        label: 'Tipo de Pagamento',
        type: 'autocomplete',
        size: 4,
        required: true,
        descriptionField: 'DS',
        valueField: 'IDTPPAGAMENTO',
        items: [
          {
            IDTPPAGAMENTO: 'QUINZENAL',
            DS: 'Quinzenal',
          },
          {
            IDTPPAGAMENTO: 'DIARIO',
            DS: 'Diário',
          },
          {
            IDTPPAGAMENTO: 'MENSAL',
            DS: 'Mensal',
          },
          {
            IDTPPAGAMENTO: 'MENSAL_SALARIO_HORA',
            DS: 'Mensal Salário Hora',
          },
          {
            IDTPPAGAMENTO: 'SEMANAL',
            DS: 'Semanal',
          },
        ],
      },
      {
        name: 'NRDIASCONTRATOEXP',
        label: 'Dias Contrato Exp.',
        type: 'number',
        size: 2,
        onInput: this.diasExpOnInput,
      },
      {
        name: 'DTVENCCONTREXPER',
        label: 'Venc. Contrato Exp.',
        type: 'date',
        size: 2,
        onInput: this.dtVencContratoOnInput,
      },
      {
        name: 'NRDIASCONTRATOEXPPRO',
        label: 'Dias Prorr. Contrato',
        type: 'number',
        size: 2,
        onInput: this.diasProrrOnInput,
      },
      {
        name: 'DTFIMCONTRDETERMIN',
        label: 'Fim Contrato Deter.',
        type: 'date',
        size: 2,
        onInput: this.dtFimContratoOnInput,
      },
      {
        name: 'NRCLAUSASSECURAT',
        label: 'Cláusula Assecuratória',
        type: 'select',
        size: 4,
        descriptionField: 'NMCLAUSASSECURAT',
        valueField: 'NRCLAUSASSECURAT',
        items: [
          {
            NRCLAUSASSECURAT: '3',
            NMCLAUSASSECURAT: 'Contrato de trabalho por prazo determinado sem cláusula assecuratória de direito recíproco de rescisão antecipada.',
          },
          {
            NRCLAUSASSECURAT: '2',
            NMCLAUSASSECURAT: 'Contrato de trabalho por prazo determinado com cláusula assecuratória de direito recíproco de rescisão antecipada.',
          },
        ],
      },
      {
        name: 'IDCONTRIBUISIND',
        label: 'Contribuição Sindical',
        type: 'select',
        size: 4,
        required: this.completa,
        descriptionField: 'DS',
        valueField: 'IDCONTRIBUISIND',
        items: [
          {
            IDCONTRIBUISIND: 'NUNCA',
            DS: 'Nunca',
          },
          {
            IDCONTRIBUISIND: 'DESCONTOU',
            DS: 'Descontou',
          },
          {
            IDCONTRIBUISIND: 'SEMPRE',
            DS: 'Sempre',
          },
        ],
      },
    ];

    return fields;
  }

  private get ocupacaoFields(): Field[] {
    const fields: Field[] = [
      {
        name: 'NRTIPOOCUPACAO',
        label: 'Tipo de Ocupação',
        type: 'autocomplete',
        size: 6,
        required: true,
        descriptionField: 'NMTIPOOCUPACAO',
        valueField: 'NRTIPOOCUPACAO',
        items: this.dadosVinculosFieldsData.tiposOcupacao,
      },
      {
        name: 'NROCUPACAOM',
        label: 'Cargo',
        type: 'autocomplete',
        size: 6,
        required: true,
        descriptionField: 'NMOCUPACAOH',
        valueField: 'NROCUPACAOM',
        items: this.dadosVinculosFieldsData.cargos,
      },
      {
        name: 'DTINIOCUPACAO',
        label: 'Data de Início',
        type: 'date',
        size: 3,
        required: this.completa,
      },
      {
        name: 'DTFIMOCUPACAO',
        label: 'Data de Fim',
        type: 'date',
        size: 3,
      },
    ];

    return fields;
  }

  private get escalaFields(): Field[] {
    const fields: Field[] = [
      {
        name: 'DTINIESCALA',
        label: 'Data de Início',
        type: 'date',
        size: 6,
        required: this.completa,
        onInput: this.getTurnoParOuImpar,
      },
      {
        name: 'DTFIMESCALA',
        label: 'Data de Fim',
        type: 'date',
        size: 6,
      },
      {
        name: 'NRESCALATRABM',
        label: 'Escala de Trabalho',
        type: 'autocomplete',
        size: 6,
        required: this.completa,
        descriptionField: 'NRNMESCALATRABM',
        valueField: 'NRESCALATRABM',
        items: this.dadosVinculosFieldsData.escalas,
        onInput: this.escalaOnInput,
      },
      {
        name: 'CDTIPODIATRABALHO',
        label: 'Turno par ou ímpar',
        type: 'radio',
        valueField: 'value',
        outData: {
          DSTIPODIATRABALHO: 'label',
        },
        items: [
          {
            label: 'Trabalho em dia ímpar',
            value: 'I',
          },
          {
            label: 'Trabalho em dia par',
            value: 'P',
          },
        ],
        size: 6,
        isVisible: this.isEscala12x36,
        required: this.isEscala12x36,
        onInput: this.getTurnoParOuImpar
      },
      {
        name: 'NRTURNO',
        label: 'Turno',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRDSTURNO',
        valueField: 'NRTURNO',
        items: this.dadosVinculosFieldsData.turnos,
        readonly: !this.rowsDadosVinculo.escala.NRESCALATRABM || this.isEscala12x36,
      },
    ];

    return fields;
  }

  private get empresaFields(): Field[] {
    const fields: Field[] = [
      {
        name: 'NRESTRUTGEREN',
        label: 'Estrutura Gerencial',
        type: 'autocomplete',
        size: 12,
        required: true,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.dadosVinculosFieldsData.estruturasGerenciais,
      },
      {
        name: 'NRESTRUTLEGAL',
        label: 'Estrutura Legal',
        type: 'autocomplete',
        size: 12,
        required: true,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.dadosVinculosFieldsData.estruturasLegais,
      },
      {
        name: 'NRESTRUTSIND',
        label: 'Estrutura Sindical',
        type: 'autocomplete',
        size: 12,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.dadosVinculosFieldsData.estruturasSindicais,
      },
      {
        name: 'NRTIPOTRANSFERADICIONAL',
        label: 'Tipo de Transferência',
        type: 'autocomplete',
        size: 4,
        descriptionField: 'NMTIPOTRANSFER',
        valueField: 'NRTIPOTRANSFER',
        items: this.dadosVinculosFieldsData.tipoTransferencia,
      },
      {
        name: 'NRESTRUTADICIONAL',
        label: 'Movimentação Adicional',
        type: 'autocomplete',
        multiple: true,
        chips: true,
        deletableChips: true,
        size: 8,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.dadosVinculosFieldsData.estruturasAdicionais,
      },
    ];

    return fields;
  }

  private get salarioFields(): Field[] {
    const fields: Field[] = [
      {
        name: 'NROCORRENCIA',
        label: 'Nr. Ocorrência',
        type: 'text',
        size: 6,
        required: this.completa,
      },
      {
        name: 'IDTPSALARIO',
        label: 'Tipo Salário',
        type: 'autocomplete',
        size: 6,
        required: true,
        descriptionField: 'DSTIPOSALARIO',
        valueField: 'CDTIPOSALARIO',
        items: this.dadosVinculosFieldsData.tiposSalario,
      },
      {
        name: 'VRSALARIO',
        label: 'Salário',
        type: 'text',
        size: 6,
        required: true,
        readonly: this.isSalarioReadOnly
      },
      {
        name: 'NRTPMODALIDSAL',
        label: 'Modalidade Salário',
        type: 'autocomplete',
        size: 6,
        required: true,
        descriptionField: 'NMTPMODALIDSAL',
        valueField: 'NRTPMODALIDSAL',
        items: this.dadosVinculosFieldsData.modalidadesSalario,
      },
    ];

    return fields;
  }
  /* FIM VÍNCULO FIELDS */

  private get enderecoFields(): Field[] {
    const fields: Field[] = [
      {
        name: 'NRCEPENDERECO',
        label: 'Número do CEP',
        size: '6',
        type: 'text',
        required: this.completa,
        mask: '#####-###',
        onInput: this.cepOnInput,
      },
      {
        name: 'CDTIPOENDERECO',
        label: 'Tipo Endereço',
        size: '6',
        type: 'autocomplete',
        required: this.completa,
        valueField: 'CDTIPOENDERECO',
        descriptionField: 'NMTIPOENDERECO',
        items: this.enderecoFieldsData.tiposEndereco,
      },
      {
        name: 'CDPAIS',
        label: 'País',
        size: 4,
        hideEmptyValue: false,
        type: 'autocomplete',
        required: this.completa,
        valueField: 'CDPAIS',
        descriptionField: 'NMPAIS',
        items: this.generalFieldsData.paises,
      },
      {
        name: 'SGESTADO',
        label: 'Estado',
        size: 4,
        hideEmptyValue: false,
        type: 'autocomplete',
        required: this.completa,
        descriptionField: 'NMESTADO',
        valueField: 'SGESTADO',
        items: this.enderecoFieldsData.estados,
        readonly: !this.rowEndereco.CDPAIS,
      },
      {
        name: 'CDMUNICIPIO',
        label: 'Município',
        size: 4,
        hideEmptyValue: false,
        type: 'autocomplete',
        required: this.completa,
        valueField: 'CDMUNICIPIO',
        descriptionField: 'NMMUNICIPIO',
        items: this.enderecoFieldsData.municipios,
        readonly: !this.rowEndereco.SGESTADO,
      },
      {
        name: 'NMBAIRROENDERECO',
        label: 'Bairro',
        size: '6',
        type: 'text',
        required: this.completa,
      },
      {
        name: 'CDLOGRADOURO',
        label: 'Logradouro',
        size: '6',
        type: 'autocomplete',
        valueField: 'CDLOGRADOURO',
        descriptionField: 'DSLOGRADOURO',
        items: this.enderecoFieldsData.logradouros,
      },
      {
        name: 'DSENDERECO',
        label: 'Endereço',
        size: '6',
        type: 'text',
      },
      {
        name: 'NRIMOVELENDERECO',
        label: 'Número',
        size: '6',
        type: 'text',
      },
      {
        name: 'DSCOMPLEENDERECO',
        label: 'Complemento',
        size: '6',
        type: 'text',
      },
      {
        name: 'DSREFERENCIAENDE',
        label: 'Referência',
        size: '6',
        type: 'text',
      },
    ];

    return fields;
  }

  private get contaFields(): Field[] {
    const fields = [
      {
        name: 'CDBANCO',
        label: 'Nr. Banco',
        size: 6,
        type: 'text',
      },
      {
        name: 'CDBANCO',
        label: 'Banco',
        size: 6,
        type: 'autocomplete',
        valueField: 'CDBANCO',
        descriptionField: 'NMBANCO',
        items: this.contaFieldsData.bancos,
      },
      {
        name: 'CDAGENCIA',
        label: 'Nr. Agência',
        size: 6,
        type: 'text',
      },
      {
        name: 'CDAGENCIA',
        label: 'Agência',
        size: 6,
        readonly: !this.rowConta.CDBANCO,
        type: 'autocomplete',
        valueField: 'CDAGENCIA',
        descriptionField: 'NMAGENCIA',
        items: this.contaFieldsData.agencias,
      },
      {
        name: 'NRTPCONTCORR',
        label: 'Tipo Conta Corrente',
        size: 6,
        type: 'autocomplete',
        descriptionField: 'DSTPCONTCORR',
        valueField: 'NRTPCONTCORR',
        items: this.contaFieldsData.tiposConta,
      },
      {
        name: 'CDCONTCORR',
        label: 'Conta Corrente',
        size: 6,
        type: 'text',
        maxlength: 30,
      },
    ];

    return fields;
  }

  private get dadosPessoaisIsValid(): boolean {
    const dadosPessoaisPanelsValidation = [
      this.panelsValidation.pessoa,
      this.panelsValidation.documentos,
      this.panelsValidation.docProf,
      this.panelsValidation.complementares,
      this.panelsValidation.documentos,
      this.panelsValidation.conselho,
      this.panelsValidation.militar,
    ];

    const isValid = Util.allTrue(...dadosPessoaisPanelsValidation);

    return isValid;
  }

  private get dadosVinculoIsValid(): boolean {
    const dadosVinculoPanelsValidation = [
      this.panelsValidation.vinculo,
      this.panelsValidation.ocupacao,
      this.panelsValidation.escala,
      this.panelsValidation.empresa,
      this.panelsValidation.salario,
    ];

    const isValid = Util.allTrue(...dadosVinculoPanelsValidation);

    return isValid;
  }

  private get isValid(): boolean {
    const validationArray = Object.values(this.panelsValidation);
    const isValid = Util.allTrue(...validationArray);

    return isValid;
  }

  private get emptyRequiredFields() {
    const pessoa = Util.getFormEmptyRequiredFields(
      this.rowsDadosPessoais.pessoa, this.pessoaFields
    );

    const vinculo = Util.getFormEmptyRequiredFields(
      this.rowsDadosVinculo.vinculo, this.vinculoFields
    );

    const ocupacao = Util.getFormEmptyRequiredFields(
      this.rowsDadosVinculo.ocupacao, this.ocupacaoFields
    );

    const escala = Util.getFormEmptyRequiredFields(
      this.rowsDadosVinculo.escala, this.escalaFields
    );

    const empresa = Util.getFormEmptyRequiredFields(
      this.rowsDadosVinculo.empresa, this.empresaFields
    );

    const salario = Util.getFormEmptyRequiredFields(
      this.rowsDadosVinculo.salario, this.salarioFields
    );

    const documentos = Util.getFormEmptyRequiredFields(
      this.rowsDadosPessoais.documentos, this.documentosFields
    );

    const docProf = Util.getFormEmptyRequiredFields(
      this.rowsDadosPessoais.docProf, this.docProfFields
    );

    const complementares = Util.getFormEmptyRequiredFields(
      this.rowsDadosPessoais.complementares, this.complementaresFields
    );

    const conselho = Util.getFormEmptyRequiredFields(
      this.rowsDadosPessoais.conselho, this.conselhoFields
    );

    const militar = Util.getFormEmptyRequiredFields(
      this.rowsDadosPessoais.militar, this.militarFields
    );

    const filiacao = Util.getFormEmptyRequiredFields(
      this.rowsDadosPessoais.filiacao, this.filiacaoFields
    );

    const endereco = Util.getFormEmptyRequiredFields(
      this.rowEndereco, this.enderecoFields
    );

    const conta = Util.getFormEmptyRequiredFields(
      this.rowConta, this.contaFields
    );

    const comunicacao = Util.getFormEmptyRequiredFields(
      this.rowComunicacao, this.comunicacaoFields
    );

    const relation = {
      pessoa: this.dadosPessoaisFormMode == 'view' ? [] : pessoa,
      vinculo,
      ocupacao,
      escala,
      empresa,
      salario,
      documentos: this.dadosPessoaisFormMode == 'view' ? [] : documentos,
      docProf: this.dadosPessoaisFormMode == 'view' ? [] : docProf,
      complementares: this.dadosPessoaisFormMode == 'view' ? [] : complementares,
      conselho: this.dadosPessoaisFormMode == 'view' ? [] : conselho,
      militar: this.dadosPessoaisFormMode == 'view' ? [] : militar,
      filiacao: this.dadosPessoaisFormMode == 'view' ? [] : filiacao,
      endereco: this.enderecoFormMode == 'view' ? [] : endereco,
      conta: this.contaCorrenteFormMode == 'view' ? [] : conta,
      comunicacao: this.comunicacaoFormMode == 'view' ? [] : comunicacao,
    };

    return relation;
  }

  private get emptyRequiredFieldsCompleta() {
    return {};
  }

  private get allEmptyRequired() {
    const emptyRequired = {
      ...this.emptyRequiredFields,
      ...this.emptyRequiredFieldsCompleta,
    };

    return emptyRequired;
  }

  private get dadosPessoaisTooltip(): string {
    const fields = [
      ...this.emptyRequiredFields.pessoa,
      ...this.emptyRequiredFields.documentos,
      ...this.emptyRequiredFields.docProf,
      ...this.emptyRequiredFields.complementares,
      ...this.emptyRequiredFields.conselho,
      ...this.emptyRequiredFields.militar,
    ];

    if (fields.length > 6) {
      return 'Preencha os campos obrigatórios!';
    }

    const tooltip = this.getPanelTooltip(fields);

    return tooltip;
  }

  private get dadosVinculoTooltip(): string {
    const fields = [
      ...this.emptyRequiredFields.vinculo,
      ...this.emptyRequiredFields.escala,
      ...this.emptyRequiredFields.ocupacao,
      ...this.emptyRequiredFields.salario,
      ...this.emptyRequiredFields.empresa,
    ];

    if (fields.length > 6) {
      return 'Preencha os campos obrigatórios!';
    }

    const tooltip = this.getPanelTooltip(fields);

    return tooltip;
  }

  private get panelsValidation() {
    const validation: {[index: string]: boolean} = {};

    const emptyRequired = this.completa ?
      this.allEmptyRequired :
      this.emptyRequiredFields;

    const panelsNames = Object.keys(emptyRequired);

    panelsNames.forEach((panelName) => {
      const value: Field[] = emptyRequired[panelName];
      const isValid = value.length === 0;

      validation[panelName] = isValid;
    });

    if (this.mode === 'view') {
      Object.keys(validation).forEach((name) => {
        validation[name] = true;
      });
    }

    if (this.completa) {
      validation['dependentes'] = this.dependentesAreValid;
    }

    return validation;
  }

  private get panelsValidationCompleta() {
    const validation: {[index: string]: boolean} = {};
    const panelsNames = Object.keys(this.emptyRequiredFieldsCompleta);

    panelsNames.forEach((panelName) => {
      const value: Field[] = this.emptyRequiredFieldsCompleta[panelName];
      const isValid = value.length === 0;

      validation[panelName] = isValid;
    });

    if (this.mode === 'view') {
      Object.keys(validation).forEach((name) => {
        validation[name] = true;
      });
    }

    return validation;
  }

  private get tooltips(): {[index: string]: string} {
    const panelsNames = Object.keys(this.allEmptyRequired);

    const tooltips = panelsNames.reduce((accumulator, panelName) => {
      const value: Field[] = this.allEmptyRequired[panelName];
      const tooltip = this.getPanelTooltip(value);

      accumulator[panelName] = tooltip;

      return accumulator;
    }, {});

    return tooltips;
  }

  private get completa(): boolean {
    return this.tipoAdmissao === 'completa';
  }

  private get dependentesAreValid(): boolean {
    // const areValid = this.rowsDependentes.reduce((accumulator: boolean, dep: any) => {
    //   const depIsValid = this.tipoDepIsSet(dep);

    //   return accumulator && depIsValid;
    // }, true);

    return true;
  }

  private get getDefaultRowEmpresa() {
    const nrEstrutGeren =
      this.estruturaGerencialAtual.IDTIPOESTRUTURA === 'GERENCIAL' ?
      this.estruturaGerencialAtual.NRESTRUTURAM :
      null;

    const defaultRow = {
      ...this.defaultRowDadosVinculoEmpresa,
      NRESTRUTGEREN: nrEstrutGeren,
    };

    return defaultRow;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    this.handleRedirectSolicitacaoAdmissao();
  }

  private mounted() {
    this.setPopupHeight();
    window.addEventListener('resize', this.setPopupHeight);
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;

    if (this.internalValue) {
      this.setDefaultRows();

      
      this.clearFields();

      if (this.mode === 'view') {
        this.setRowsFromProp();
      }

      if (!this.dataIsLoaded) {
        this.loadFieldsData();
      }

      this.loadPessoaEnderecoFieldsData();
      this.loadSolicitacoesAdmissao();

      this.openPanels();
    }
  }
  // #endregion

  // #region [ METHODS ]
  private closeDialog() {
    this.internalValue = false;
    this.emitInput(this.internalValue);
    this.makeDadosPessoaisPopupsEditable();
  }

  private setDefaultRows() {
    const defaultRowEnderecoCopy = Util.deepCopy(this.defaultRowEndereco);
    this.rowEndereco = defaultRowEnderecoCopy;
    this.isEscala12x36 = false;

    const defaultRowDadosPessoaisPessoaCopy = Util.deepCopy(this.defaultRowDadosPessoaisPessoa);
    this.rowsDadosPessoais.pessoa = defaultRowDadosPessoaisPessoaCopy;

    const defaultRowConta = Util.deepCopy(this.defaultRowConta);
    this.rowConta = defaultRowConta;
  }

  private contaOnFieldInput(fieldName: string) {
    if (fieldName === 'CDBANCO') {
      this.contaBancoOnChange();
    }
  }

  private contaBancoOnChange() {
    const cdBanco: string = this.rowConta.CDBANCO;

    this.rowConta.CDAGENCIA = null;

    if (cdBanco) {
      this.loadAgencias();
    }
  }

  private enderecoOnFieldInput(fieldName: string) {
    if (fieldName === 'CDPAIS') {
      this.enderecoPaisOnChange();
    }

    if (fieldName === 'SGESTADO') {
      this.enderecoEstadoOnChange();
    }
  }

  private enderecoPaisOnChange() {
    this.rowEndereco.SGESTADO = null;
    this.rowEndereco.CDMUNICIPIO = null;

    if (this.rowEndereco.CDPAIS) {
      this.loadEnderecoEstados();
    }
  }

  private enderecoEstadoOnChange() {
    this.rowEndereco.CDMUNICIPIO = null;

    if (this.rowEndereco.SGESTADO) {
      this.loadEnderecoMunicipios();
    }
  }

  private pessoaOnFieldInput(fieldName: string) {
    if (fieldName === 'CDPAISNATURALI') {
      this.pessoaPaisOnChange();
    }

    if (fieldName === 'SGESTADONATURALI') {
      this.pessoaEstadoOnChange();
    }
  }

  private operadorOnFieldInput(fieldName: string) {
    if (fieldName === 'CDPAISNATURALI') {
      this.pessoaPaisOnChange();
    }

    if (fieldName === 'SGESTADONATURALI') {
      this.pessoaEstadoOnChange();
    }
  }

  private pessoaPaisOnChange() {
    this.rowsDadosPessoais.pessoa.SGESTADONATURALI = null;
    this.rowsDadosPessoais.pessoa.CDMUNICIPIONATURALI = null;

    if (this.rowsDadosPessoais.pessoa.CDPAISNATURALI) {
      this.loadPessoaEstados();
    }
  }

  private pessoaEstadoOnChange() {
    this.rowsDadosPessoais.pessoa.CDMUNICIPIONATURALI = null;

    if (this.rowsDadosPessoais.pessoa.SGESTADONATURALI) {
      this.loadPessoaMunicipios();
    }
  }

  private empresaOnFieldInput(fieldName: string) {
    if (fieldName === 'NRESTRUTGEREN') {
      this.setEstruturaLegalByGeren();
    }
  }

  private setEstruturaLegalByGeren() {
    const nrEstrutGeren = this.rowsDadosVinculo.empresa.NRESTRUTGEREN;

    if(nrEstrutGeren) {
      const estruturaGeren = this.dadosVinculosFieldsData.estruturasGerenciais.find((estrutura) => estrutura.NRESTRUTURAM == nrEstrutGeren);
      if(estruturaGeren && estruturaGeren.NRESTRUTLEGAL) {
        this.rowsDadosVinculo.empresa.NRESTRUTLEGAL = estruturaGeren.NRESTRUTLEGAL;
      }
    }
  }


  private async saveAdmissao() {
    if (!this.isValid) {
      const message = 'Preencha todos os campos obrigatórios!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      return;
    }

    if(!this.validarDtAdmissao(true)) {
      return;
    }

    const isVinculoSubsValid = this.verificaSolicitacaoSubstituicaoVinculo();
    if(!isVinculoSubsValid ) return;

    const isValidEstrutura = await this.validationEstrutGerenELegal();
    if(!isValidEstrutura) return;

    if (!this.validarDocumentos()) {
      return;
    }
  
    //await this.verificaVinculoExistente();

    await DialogUtils.show('Finalizar admissão', 'Deseja realmente finalizar a admissão? Após finalizar ainda será necessária a aprovação do DP via HCM.');

    const documentos = await this.getDocumentosArray();

    const dadosPessoais = {
      ...this.rowsDadosPessoais.pessoa,
      ...this.rowsDadosPessoais.documentos,
      ...this.rowsDadosPessoais.docProf,
      ...this.rowsDadosPessoais.complementares,
      ...this.rowsDadosPessoais.conselho,
      ...this.rowsDadosPessoais.militar,
    };

    const operador = {
      ...this.rowsDadosPessoais.operador,
      NRCPFPESSOA: this.rowsDadosPessoais.documentos.NRCPFPESSOA,
    }

    const row: any = {
      dadosPessoais,
      documentos,
      operador,
      endereco: this.rowEndereco,
      conta: this.rowConta,
      comunicacao: this.rowComunicacao,
    };

    const dadosVinculo = {
      ...this.rowsDadosVinculo.empresa,
      ...this.rowsDadosVinculo.escala,
      ...this.rowsDadosVinculo.ocupacao,
      ...this.rowsDadosVinculo.salario,
      ...this.rowsDadosVinculo.vinculo,
    };

    row.dadosVinculo = dadosVinculo;

    if (this.completa) {
      row.dadosPessoais.filiacao = this.rowsDadosPessoais.filiacao;
      row.dependentes = this.rowsDependentes;
      row.formacao = this.rowsFormacao;
      row.vt = this.rowsValeTransporte;
      row.beneficios = this.rowsBeneficios;
    }

    try {
      let data = null;
      if (this.completa) {
        data = await AdmissaoController.setAdmissaoCompleta(row);
      } else {
        data = await AdmissaoController.setAdmissaoSimplificada(row);
      }

      const message = 'Admissão pendente para aprovação.';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_SUCCESS);

      this.closeDialog();
      this.emitAfterSave();
    } catch (err) {
      const message = err instanceof ExpectedError ?
        err.message :
        'Não foi possível realizar a admissão!';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  private validarDocumentos() {
    if (!this.validarCPF()) {
      return false;
    };

    if (!this.validarPIS()) {
      return false;
    };

    return true;
  }

  private validarCPF() {
    const cpf: string = this.rowsDadosPessoais.documentos.NRCPFPESSOA;
    const isValid = DocumentoUtil.validaCPF(cpf);

    if (!isValid) {
      const message = 'CPF inválido!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
      this.$nextTick(() => {
        const documentos = Util.deepCopy(this.rowsDadosPessoais.documentos);
        this.rowsDadosPessoais.documentos = { ...documentos, NRCPFPESSOA: null };
      });
    }

    return isValid;
  }

  private async validarDtAdmissao(isDialog: boolean) {
    const dtAtual = new Date(); 
    const dtAdmissao = parse(this.rowsDadosVinculo.vinculo.DTADMISSAOVINC, 'dd/MM/yyyy', new Date());

    if(isBefore(dtAdmissao, dtAtual) || isSameDay(dtAdmissao, dtAtual)) {
      if(isDialog) {
       await DialogUtils.show('Aviso', Messages.AVISO_ESO_PENSALIDADE_REGISTRO_DATA); 
      }
      else {
        SnackbarUtils.showMessage(Messages.AVISO_ESO_PENSALIDADE_REGISTRO_DATA, SnackbarUtils.TYPE_ERROR);
      }
    }

    return true;
  }

  private onFieldInput(fieldName, value) {
  }

  private onCpfInput() {
    this.validarCPF();
    const cpf: string = this.rowsDadosPessoais.documentos.NRCPFPESSOA;
    this.getDadosCpf(cpf);
  }

  private async getDadosCpf(nrCpf){
    try {  
      if(Util.isEmptyOrBlank(nrCpf)){
        this.makeDadosPessoaisPopupsEditable();
        this.clearFields(true);
        this.cpfDados = null;
        this.vinculoCpf = null;
        return;
      }

      const [response, vinculoResp] = await Promise.all([
        AdmissaoController.buscarPessoaCPF(nrCpf),
        VinculoController.getVinculoByCPF(nrCpf.replace(/\D/g,''))
      ]);

      this.vinculoCpf = vinculoResp;

      if (Util.isEmptyOrBlank(response)) {
        return;
      }

      this.cpfDados = response;
      
      if(response.VINCULOATIVO == 'S'){
        this.rowsDadosVinculo.vinculo.IDMULTVINC = 'PRIMARIO';
      }else{
        this.rowsDadosVinculo.vinculo.IDMULTVINC = 'UNICO';
      }

      await this.verificaVinculoExistente();

      const dadosPessoaisResponse = {
        NMPESSOA: response.NMPESSOA,
        DTNASCPESSOA: response.DTNASCPESSOA,
        NRGRAUINSTR: response.NRGRAUINSTR,
        NRNACIONALID: response.NRNACIONALID
      }

      const dadosDocumentosResponse = {
        NRRGPESSOA: response.NRRGPESSOA,
        CDEXRGPESSOA: response.CDEXRGPESSOA,
        DTEXRGPESSOA: response.DTEXRGPESSOA,
        SGUFRGPESSOA: response.SGUFRGPESSOA
      }

      const dadosDocumentosProfResponse = {
        NRCTPSPESSOA: response.NRCTPSPESSOA,
        NRSERIECTPSPES: response.NRSERIECTPSPES,
        DTCTPSPESSOA: response.DTCTPSPESSOA,
        NRPISPASEPPES: response.NRPISPASEPPES
      }

      const dadosEnderecoResponse = {
        NRCEPENDERECO: response.NRCEPENDERECO,
        CDPAIS: response.CDPAIS,
        SGESTADO: response.SGESTADO,
        CDMUNICIPIO: response.CDMUNICIPIO,
        NMBAIRROENDERECO: response.NMBAIRROENDERECO,
        CDLOGRADOURO: response.CDLOGRADOURO,
        DSENDERECO: response.DSENDERECO
      }

      if (Util.isEmptyOrBlank(response.DEPENDENTES)) {
        response.DEPENDENTES = [];
      }
      if(this.completa) {
        const dadosDependentes = response.DEPENDENTES.map((dependente) => {
          return {
            NRPESSOA: dependente.NRPESSOA,
            NMPESSOA: dependente.NMPESSOA,
            DTNASCIFUNDPARC: dependente.DTNASCIFUNDPARC,
            IDSEXOPESSOA: dependente.IDSEXOPESSOA,
            DSSEXOPESSOA: dependente.IDSEXOPESSOA == 'F' ? 'Feminino' : 'Masculino',
            CDESTACIVIL: dependente.CDESTACIVIL,
            NRNACIONALIDADE: dependente.NRNACIONALID,
            CDPAIS: dependente.CDPAIS,
            SGESTADO: dependente.SGESTADO,
            CDMUNICIPIO: dependente.CDMUNICIPIO,
            NMTIPORELACIONA: dependente.NMTIPORELACIONA,
            NRTIPORELACIONA: dependente.NRTIPORELACIONA,
            NRCPFPESSOA: dependente.NRCPFPESSOA,
            DTFIMRELACIONAMENTO: dependente.DTFIMRELACIONAMENTO,
            NRPARCNEGOCIO: dependente.NRPARCNEGOCIO
          }
        });

        this.rowsDependentes = dadosDependentes;
        if(!Util.isEmptyOrBlank(this.rowsDependentes)) {
          SnackbarUtils.showMessage(Messages.ADMS_DEP_ADD_SEM_TIPO, SnackbarUtils.TYPE_ALERT);
        }
      }


      this.rowsDadosPessoais = {
        ...this.rowsDadosPessoais,
        pessoa: {
          ...this.rowsDadosPessoais.pessoa,
          ...dadosPessoaisResponse
        },
        documentos: {
          ...this.rowsDadosPessoais.documentos,
          ...dadosDocumentosResponse
        },
        docProf: {
          ...this.rowsDadosPessoais.docProf,
          ...dadosDocumentosProfResponse
        }
      }

      this.rowEndereco = {
        ...this.rowEndereco,
        ...dadosEnderecoResponse
      };

      this.fillDirectlyByCep(response.NRCEPENDERECO); 
      this.makeDadosPessoaisPopupsReadOnly();

    } catch(e) {
      SnackbarUtils.showMessage(Messages.LOGIN_FAIL, SnackbarUtils.TYPE_ALERT);
      this.vinculoCpf = null;
    }
  }

  private makeDadosPessoaisPopupsReadOnly() {
    this.dadosPessoaisFormMode = 'view';
    this.enderecoFormMode = 'view';
    this.contaCorrenteFormMode = 'view';
    this.comunicacaoFormMode = 'view';
  }

  private makeDadosPessoaisPopupsEditable() {
    this.dadosPessoaisFormMode = 'edit';
    this.enderecoFormMode = 'edit';
    this.contaCorrenteFormMode = 'edit';
    this.comunicacaoFormMode = 'edit';
  }

  private validarPIS() {
    const pis: string = this.rowsDadosPessoais.docProf.NRPISPASEPPES;

    if (!pis) {
      return true;
    }

    const isValid = DocumentoUtil.validaPIS(pis);

    if (!isValid) {
      const message = 'PIS inválido!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      this.$nextTick(() => {
        const documentos = Util.deepCopy(this.rowsDadosPessoais.docProf);
        this.rowsDadosPessoais.docProf = { ...documentos, NRPISPASEPPES: null };
      });
    }

    return isValid;
  }




  private showErrorMessage(fieldName: string) {
    const message = `
      Não foi possível carregar os dados do campo "${fieldName}"!`;

    SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR, 5000);
  }

  private async loadFieldsData() {
    if (this.loaded) {
      return;
    }

    this.loaded = true;

    this.loadGeneralFieldsData();
    this.loadDadosPessoaisFieldsData();
    this.loadEnderecoFieldsData();
    this.loadContaFieldsData();
    this.loadVinculoFieldsData();
  }

  private loadGeneralFieldsData() {
    this.loadPaises();
    this.loadEstadosBR();
  }

  private async loadPaises() {
    try {
      const paises = await AdmissaoController.getPais();
      this.generalFieldsData.paises = paises;
    } catch {
      this.showErrorMessage('País');
    }
  }

  private async loadEstadosBR() {
    try {
      const estadosBR = await AdmissaoController.getEstado();
      this.generalFieldsData.estadosBR = estadosBR;
    } catch {
      this.showErrorMessage('Estado');
    }
  }




  private loadDadosPessoaisFieldsData() {
    this.loadEstadosCivis();
    this.loadCondicoesFisicas();
    this.loadRacas();
    this.loadGrausInstrucao();
    this.loadNacionalidades();
    this.loadClassificacoesEstrangeiro();
    this.loadConselhos();
    this.loadCategoriasMilitares();
    this.loadPessoaEnderecoFieldsData();
  }

  private loadPessoaEnderecoFieldsData() {
    if (this.rowsDadosPessoais.pessoa.CDPAISNATURALI) {
      this.loadPessoaEstados();
    }

    if (this.rowsDadosPessoais.pessoa.SGESTADONATURALI) {
      this.loadPessoaMunicipios();
    }
  }

  private async loadEstadosCivis() {
    try {
      const estadosCivis = await AdmissaoController.getEstadocivil();
      this.dadosPessoaisFieldsData.estadosCivis = estadosCivis;
    } catch {
      this.showErrorMessage('Estado Civil');
    }
  }

  private async loadCondicoesFisicas() {
    try {
      const condicoesFisicas = await AdmissaoController.getCondicaoFisica();
      this.dadosPessoaisFieldsData.condicoesFisicas = condicoesFisicas;
    } catch {
      this.showErrorMessage('Condição Física');
    }
  }

  private async loadRacas() {
    try {
      const racas = await AdmissaoController.getRacaPessoa();
      this.dadosPessoaisFieldsData.racas = racas;
    } catch {
      this.showErrorMessage('Raça');
    }
  }

  private async loadGrausInstrucao() {
    try {
      const grausInstrucao = await AdmissaoController.getGrauinstrucao();
      this.dadosPessoaisFieldsData.grausInstrucao = grausInstrucao;
    } catch {
      this.showErrorMessage('Grau de Instrução');
    }
  }

  private async loadNacionalidades() {
    try {
      const nacionalidades = await AdmissaoController.getNacionalidade();
      this.dadosPessoaisFieldsData.nacionalidades = nacionalidades;
    } catch {
      this.showErrorMessage('Nacionalidade');
    }
  }

  private async loadClassificacoesEstrangeiro() {
    try {
      const classificacoesEstrangeiro = await AdmissaoController.getClasseEstrang();
      this.dadosPessoaisFieldsData.classificacoesEstrangeiro = classificacoesEstrangeiro;
    } catch {
      this.showErrorMessage('Classificação Trabalhador Estrangeiro');
    }
  }

  private async loadConselhos() {
    try {
      const conselhos = await AdmissaoController.getConselhoRegional();
      this.dadosPessoaisFieldsData.conselhos = conselhos;
    } catch {
      this.showErrorMessage('Conselho Regional');
    }
  }

  private async loadCategoriasMilitares() {
    try {
      const categoriasMilitares = await AdmissaoController.getCategoriaMilitar();
      this.dadosPessoaisFieldsData.categoriasMilitares = categoriasMilitares;
    } catch {
      this.showErrorMessage('Categoria Militar');
    }
  }




  private loadEnderecoFieldsData() {
    this.loadTiposEndereco();
    this.loadLogradouros();
    this.loadEnderecoEstados();
  }

  private async loadTiposEndereco() {
    try {
      const tiposEndereco = await AdmissaoController.getTpEndereco();
      this.enderecoFieldsData.tiposEndereco = tiposEndereco;
    } catch {
      this.showErrorMessage('Tipo Endereço');
    }
  }

  private async loadLogradouros() {
    try {
      const logradouros = await AdmissaoController.getLogradouro();
      this.enderecoFieldsData.logradouros = logradouros;
    } catch {
      this.showErrorMessage('Endereço → Logradouro');
    }
  }

  private async loadEnderecoEstados() {
    try {
      const cdPais: string = this.rowEndereco.CDPAIS;

      if (!cdPais) {
        return;
      }

      const estados = await AdmissaoController.getEstado(cdPais);

      this.enderecoFieldsData.estados = estados;
    } catch {
      this.showErrorMessage('Endereço → Estado');
    }
  }

  private async loadEnderecoMunicipios() {
    try {
      const cdPais: string = this.rowEndereco.CDPAIS;
      const sgEstado: string = this.rowEndereco.SGESTADO;
      const municipios = await AdmissaoController.getMunicipio(cdPais, sgEstado);

      this.enderecoFieldsData.municipios = municipios;
    } catch {
      this.showErrorMessage('Município');
    }
  }

  private async loadPessoaEstados() {
    try {
      const cdPais: string = this.rowsDadosPessoais.pessoa.CDPAISNATURALI;
      const estados = await AdmissaoController.getEstado(cdPais);

      this.dadosPessoaisFieldsData.estados = estados;
    } catch {
      this.showErrorMessage('Dados Pessoais → Pessoa → Estado');
    }
  }

  private async loadPessoaMunicipios() {
    try {
      const cdPais: string = this.rowsDadosPessoais.pessoa.CDPAISNATURALI;
      const sgEstado: string = this.rowsDadosPessoais.pessoa.SGESTADONATURALI;
      const municipios = await AdmissaoController.getMunicipio(cdPais, sgEstado);

      this.dadosPessoaisFieldsData.municipios = municipios;
    } catch {
      this.showErrorMessage('Dados Pessoais → Pessoa → Município');
    }
  }




  private loadContaFieldsData() {
    this.loadBancos();
    this.loadTiposConta();
  }

  private async loadBancos() {
    try {
      const bancos = await AdmissaoController.getBanco();
      this.contaFieldsData.bancos = bancos;
    } catch {
      this.showErrorMessage('Banco');
    }
  }

  private async loadTiposConta() {
    try {
      const tiposConta = await AdmissaoController.getTpContaCorrente();
      this.contaFieldsData.tiposConta = tiposConta;
    } catch {
      this.showErrorMessage('Tipo Conta Corrente');
    }
  }

  private async loadAgencias() {
    try {
      const cdBanco: string = this.rowConta.CDBANCO;

      if (!cdBanco) {
        return;
      }

      const agencias = await AdmissaoController.getAgencia(cdBanco);
      this.contaFieldsData.agencias = agencias;
    } catch {
      this.showErrorMessage('Agência');
    }
  }

  private saveDocumento(row: any) {
    if (this.documentosGrid.currentRow !== null) {
      // Substitui a row antiga pela editada
      Util.replaceItem(row, this.rowsDocumentos, (doc: any) => {
        return doc.__id === row.__id;
      });
    } else {
      this.rowsDocumentos.push(row);
    }

    this.closeDocumentoPopup();
  }

  private addDocumento() {
    this.documentosGrid.currentRow = null;
    this.documentosGrid.showPopup = true;
  }

  private editDocumento(row: any) {
    this.documentosGrid.currentRow = row;
    this.documentosGrid.showPopup = true;
  }

  private closeDocumentoPopup() {
    this.documentosGrid.showPopup = false;
  }

  private setRowsFromProp() {
    this.setDadosPessoaisRowFromProp();
    this.setEnderecoRowFromProp();
    this.setContaRowFromProp();
    this.setComunicacaoRowFromProp();
    this.rowsDocumentos = [];

    this.loadDependentFields();
  }

  private setDadosPessoaisRowFromProp() {
    this.rowsDadosPessoais.pessoa.DSPRONOMETRAT = this.row.DSPRONOMETRAT;
    this.rowsDadosPessoais.pessoa.NMPESSOA = this.row.NMPESSOA;
    this.rowsDadosPessoais.pessoa.DSAPELIDOPESS = this.row.DSAPELIDOPESS;
    this.rowsDadosPessoais.pessoa.DTNASCPESSOA = Util.dateAndTimeToDate(this.row.DTNASCPESSOA);
    this.rowsDadosPessoais.pessoa.IDSEXOPESSOA = this.row.IDSEXOPESSOA;
    this.rowsDadosPessoais.pessoa.CDESTACIVIL = this.row.CDESTACIVIL;
    this.rowsDadosPessoais.pessoa.IDGRUPSANGUPES = this.row.IDGRUPSANGUPES;
    this.rowsDadosPessoais.pessoa.IDFATORRHPES = this.row.IDFATORRHPES;
    this.rowsDadosPessoais.pessoa.NRCONDFISPES = this.row.NRCONDFISPES;
    this.rowsDadosPessoais.pessoa.IDCOTAPCD = this.row.IDCOTAPCD;
    this.rowsDadosPessoais.pessoa.NRRACAPESSOA = this.row.NRRACAPESSOA;
    this.rowsDadosPessoais.pessoa.NRGRAUINSTR = this.row.NRGRAUINSTR;this.rowsDadosPessoais.documentos
    this.rowsDadosPessoais.pessoa.CDPAISNATURALI = this.row.CDPAISNATURALI;
    this.rowsDadosPessoais.pessoa.SGESTADONATURALI = this.row.SGESTADONATURALI;
    this.rowsDadosPessoais.pessoa.CDMUNICIPIONATURALI = this.row.CDMUNICIPIONATURALI;
    this.rowsDadosPessoais.pessoa.NRNACIONALID = this.row.NRNACIONALID;
    this.rowsDadosPessoais.pessoa.DTADMISSAOPRE = this.row.DTADMISSAOPRE;
    this.rowsDadosPessoais.pessoa.CDRECIBOADMPRE = this.row.CDRECIBOADMPRE;

    this.rowsDadosPessoais.documentos.NRCPFPESSOA = this.row.NRCPFPESSOA;
    this.rowsDadosPessoais.documentos.NRRGPESSOA = this.row.NRRGPESSOA;
    this.rowsDadosPessoais.documentos.CDEXRGPESSOA = this.row.CDEXRGPESSOA;
    this.rowsDadosPessoais.documentos.DTEXRGPESSOA = Util.dateAndTimeToDate(this.row.DTEXRGPESSOA);
    this.rowsDadosPessoais.documentos.DSLOCALEXRGPES = this.row.DSLOCALEXRGPES;
    this.rowsDadosPessoais.documentos.SGUFRGPESSOA = this.row.SGUFRGPESSOA;
    this.rowsDadosPessoais.documentos.NRSUSPESSOA = this.row.NRSUSPESSOA;
    this.rowsDadosPessoais.documentos.NRNITPESSOA = this.row.NRNITPESSOA;
    this.rowsDadosPessoais.documentos.NRTITUELEIPES = this.row.NRTITUELEIPES;
    this.rowsDadosPessoais.documentos.NRZONAELEIPES = this.row.NRZONAELEIPES;
    this.rowsDadosPessoais.documentos.NRSECAELEIPES = this.row.NRSECAELEIPES;
    this.rowsDadosPessoais.documentos.IDISENTITUELEI = this.row.IDISENTITUELEI;
    this.rowsDadosPessoais.documentos.NRCERTNASCPES = this.row.NRCERTNASCPES;
    this.rowsDadosPessoais.documentos.NRLIVROCERTNASC = this.row.NRLIVROCERTNASC;
    this.rowsDadosPessoais.documentos.NRFOLHACERTNASC = this.row.NRFOLHACERTNASC;
    this.rowsDadosPessoais.documentos.DSCOMPLCERTNASC = this.row.DSCOMPLCERTNASC;
    this.rowsDadosPessoais.documentos.NRCERTOBITO = this.row.NRCERTOBITO;
    this.rowsDadosPessoais.documentos.NRCERTCASAPES = this.row.NRCERTCASAPES;
    this.rowsDadosPessoais.documentos.DTCASAPESSOA = Util.dateAndTimeToDate(this.row.DTCASAPESSOA);
    this.rowsDadosPessoais.documentos.NRCARTHABPES = this.row.NRCARTHABPES;
    this.rowsDadosPessoais.documentos.DTHABCARTPES = Util.dateAndTimeToDate(this.row.DTHABCARTPES);
    this.rowsDadosPessoais.documentos.DSCATEGHABCART = this.row.DSCATEGHABCART;
    this.rowsDadosPessoais.documentos.DTVALHABCARTPES = Util.dateAndTimeToDate(this.row.DTVALHABCARTPES);
    this.rowsDadosPessoais.documentos.SGUFHABCARPES = this.row.SGUFHABCARPES;

    this.rowsDadosPessoais.docProf.NRCTPSPESSOA = this.row.NRCTPSPESSOA;
    this.rowsDadosPessoais.docProf.NRSERIECTPSPES = this.row.NRSERIECTPSPES;
    this.rowsDadosPessoais.docProf.SGUFCTPSPES = this.row.SGUFCTPSPES;
    this.rowsDadosPessoais.docProf.DTCTPSPESSOA = Util.dateAndTimeToDate(this.row.DTCTPSPESSOA);
    this.rowsDadosPessoais.docProf.NRPISPASEPPES = this.row.NRPISPASEPPES;
    this.rowsDadosPessoais.docProf.DTINSCPISPASEP = Util.dateAndTimeToDate(this.row.DTINSCPISPASEP);
    this.rowsDadosPessoais.docProf.NRINSCINSSPES = this.row.NRINSCINSSPES;
    this.rowsDadosPessoais.docProf.NRINSCISSPES = this.row.NRINSCISSPES;
    this.rowsDadosPessoais.docProf.NRREGCTPSPES = this.row.NRREGCTPSPES;

    this.rowsDadosPessoais.complementares.DSEXPDOCESTR = this.row.DSEXPDOCESTR;
    this.rowsDadosPessoais.complementares.NRCLASSESTRANG = this.row.NRCLASSESTRANG;
    this.rowsDadosPessoais.complementares.DTCHEGADAPAIS = Util.dateAndTimeToDate(this.row.DTCHEGADAPAIS);
    this.rowsDadosPessoais.complementares.NRDOCUESTRANG = this.row.NRDOCUESTRANG;
    this.rowsDadosPessoais.complementares.IDPESNATURALIZA = this.row.IDPESNATURALIZA;
    this.rowsDadosPessoais.complementares.DTNATURALIZAPES = Util.dateAndTimeToDate(this.row.DTNATURALIZAPES);
    this.rowsDadosPessoais.complementares.IDPOSVISTOPERM = this.row.IDPOSVISTOPERM;
    this.rowsDadosPessoais.complementares.DTPERMAVISTO = Util.dateAndTimeToDate(this.row.DTPERMAVISTO);

    this.rowsDadosPessoais.conselho.NRCONSELHOREG = this.row.NRCONSELHOREG;
    this.rowsDadosPessoais.conselho.NRINSCRCONSREG = this.row.NRINSCRCONSREG;
    this.rowsDadosPessoais.conselho.DTEXCONSREG = Util.dateAndTimeToDate(this.row.DTEXCONSREG);
    this.rowsDadosPessoais.conselho.SGESTADO = this.row.SGESTADO;
    this.rowsDadosPessoais.conselho.SGUFCONSREG = this.row.SGUFCONSREG;
    this.rowsDadosPessoais.conselho.DTINIVIGENCIA = Util.dateAndTimeToDate(this.row.DTINIVIGENCIA);
    this.rowsDadosPessoais.conselho.DTFIMVIGENCIA = Util.dateAndTimeToDate(this.row.DTFIMVIGENCIA);

    this.rowsDadosPessoais.militar.NRCATMILITARPE = this.row.NRCATMILITARPE;
    this.rowsDadosPessoais.militar.NRCERTRESEPES = this.row.NRCERTRESEPES;
    this.rowsDadosPessoais.militar.CDEXCERTRESEPES = this.row.CDEXCERTRESEPES;
    this.rowsDadosPessoais.militar.DSCATEGCERTRESE = this.row.DSCATEGCERTRESE;
    this.rowsDadosPessoais.militar.DTCERTRESEPES = Util.dateAndTimeToDate(this.row.DTCERTRESEPES);
  }

  private setEnderecoRowFromProp() {
    this.rowEndereco.NRCEPENDERECO = this.row.NRCEPENDERECO;
    this.rowEndereco.CDTIPOENDERECO = this.row.CDTIPOENDERECO;
    this.rowEndereco.CDPAIS = this.row.CDPAIS;
    this.rowEndereco.SGESTADO = this.row.SGESTADO;
    this.rowEndereco.CDMUNICIPIO = this.row.CDMUNICIPIO;
    this.rowEndereco.NMBAIRROENDERECO = this.row.NMBAIRROENDERECO;
    this.rowEndereco.CDLOGRADOURO = this.row.CDLOGRADOURO;
    this.rowEndereco.DSENDERECO = this.row.DSENDERECO;
    this.rowEndereco.NRIMOVELENDERECO = this.row.NRIMOVELENDERECO;
    this.rowEndereco.DSCOMPLEENDERECO = this.row.DSCOMPLEENDERECO;
    this.rowEndereco.DSREFERENCIAENDE = this.row.DSREFERENCIAENDE;
  }

  private setContaRowFromProp() {
    this.rowConta.CDBANCO = this.row.CDBANCO;
    this.rowConta.CDAGENCIA = this.row.CDAGENCIA;
    this.rowConta.NRTPCONTCORR = this.row.NRTPCONTCORR;
    this.rowConta.CDCONTCORR = this.row.CDCONTCORR;
  }

  private setComunicacaoRowFromProp() {
    this.rowComunicacao.PREFTELPRINCIPAL = this.row.PREFTELPRINCIPAL;
    this.rowComunicacao.TELPRINCIPAL = this.row.TELPRINCIPAL;
    this.rowComunicacao.PREFTELRESIDEN = this.row.PREFTELRESIDEN;
    this.rowComunicacao.TELRESIDEN = this.row.TELRESIDEN;
    this.rowComunicacao.PREFTELCOMERC = this.row.PREFTELCOMERC;
    this.rowComunicacao.TELCOMERC = this.row.TELCOMERC;
    this.rowComunicacao.PREFCELPARTIC = this.row.PREFCELPARTIC;
    this.rowComunicacao.CELPARTIC = this.row.CELPARTIC;
    this.rowComunicacao.PREFCELCOMERC = this.row.PREFCELCOMERC;
    this.rowComunicacao.CELCOMERC = this.row.CELCOMERC;
    this.rowComunicacao.PREFFAX = this.row.PREFFAX;
    this.rowComunicacao.FAX = this.row.FAX;
    this.rowComunicacao.EMAIL = this.row.EMAIL;
  }

  private clearFields(isCPF: boolean = false) {
    const nrSolicitacao = isCPF ? this.rowsDadosPessoais.documentos.NRSOLICITACAO : null;

    this.rowsDadosPessoais.pessoa = Util.deepCopy(this.defaultRowDadosPessoaisPessoa);
    this.rowsDadosPessoais.operador = Util.deepCopy(this.defaultRowDadosPessoaisOperador);
    this.rowsDadosPessoais.complementares = {};
    this.rowsDadosPessoais.conselho = {};
    this.rowsDadosPessoais.docProf = {};
    this.rowsDadosPessoais.documentos = {};
    this.rowsDadosPessoais.documentos.NRSOLICITACAO = nrSolicitacao;
    this.rowsDadosPessoais.militar = {};

    this.rowsDadosVinculo.vinculo = Util.deepCopy(this.defaultRowDadosVinculo);
    this.rowsDadosVinculo.ocupacao = Util.deepCopy(this.defaultRowDadosVinculoOcupacao);
    this.rowsDadosVinculo.escala = Util.deepCopy(this.defaultRowDadosVinculoEscala);
    this.rowsDadosVinculo.empresa = Util.deepCopy(this.getDefaultRowEmpresa);
    this.rowsDadosVinculo.salario = Util.deepCopy(this.defaultRowDadosVinculoSalario);

    this.rowsDependentes = [];
    this.rowsBeneficios = [];
    this.rowsValeTransporte = [];
    this.rowsFormacao = [];

    this.rowEndereco = Util.deepCopy(this.defaultRowEndereco);
    this.rowComunicacao = {};
    this.rowConta = Util.deepCopy(this.defaultRowConta);
    this.rowsDocumentos = [];
  }

  private loadDependentFields() {
    if (this.rowsDadosPessoais.pessoa.CDPAISNATURALI) {
      this.loadPessoaEstados();
    }

    if (this.rowsDadosPessoais.pessoa.SGESTADONATURALI) {
      this.loadPessoaMunicipios();
    }

    if (this.rowEndereco.CDPAIS) {
      this.loadEnderecoEstados();
    }

    if (this.rowEndereco.SGESTADO) {
      this.loadEnderecoMunicipios();
    }

    if (this.rowConta.CDBANCO) {
      this.loadAgencias();
    }
  }

  private async getDocumentosArray() {
    const rowsDocumentosCopy = Util.deepCopy(this.rowsDocumentos);

    for (const fileRow of rowsDocumentosCopy) {
      const fileName = fileRow.FILE.name;

      try {
        const file = fileRow.FILE;
        const base64 = await FileUtils.toBase64(file);

        fileRow.FILE = base64;
      } catch (err) {
        const message = `Não foi possível carregar o arquivo "${fileName}"!`;
        SnackbarUtils.showMessage(message, 'alert', 5000);

        throw err;
      }
    }

    return rowsDocumentosCopy;
  }

  private setPopupHeight() {
    const windowHeight = window.innerHeight;
    this.dialogHeight = windowHeight - 218;
  }

  private openPanels() {
    this.mainPanelsExpansion = Util.deepCopy(this.defaultMainPanelsExpansion);
    this.dadosPessoaisPanelsExpansion = Util.deepCopy(this.defaultDadosPessoaisPanelsExpansion);
    this.dadosVinculoPanelsExpansion = Util.deepCopy(this.defaultDadosVinculoPanelsExpansion);
  }

  private getPanelTooltip(
    emptyRequiredFields: Field[],
  ): string {
    const lastIndex = emptyRequiredFields.length - 1;

    if (emptyRequiredFields.length === 0) {
      return 'Campos obrigatórios preenchidos.';
    }

    const tooltip = emptyRequiredFields.reduce((accumulator, field, index) => {
      accumulator += `"${field.label}"`;

      accumulator += index === lastIndex ?
        '.' :
        ', ';

      return accumulator;
    }, 'Preencha os campos: ');

    return tooltip;
  }

  private onSaveDependente(row: any) {
    if (this.dependentesGrid.currentRow !== null) {
      // Substitui a row antiga pela editada
      Util.replaceItem(row, this.rowsDependentes, (dep: any) => {
        return dep.__id === row.__id;
      });
    } else {
      this.rowsDependentes.push(row);
    }

    this.dependentesGrid.showPopup = false;
  }

  private addDep() {
    this.dependentesGrid.currentRow = null;
    this.dependentesGrid.showPopup = true;
  }

  private editDep(dep: any) {
    this.dependentesGrid.currentRow = dep;
    this.dependentesGrid.showPopup = true;
  }

  private onSaveVT(row: any) {
    if (this.vtGrid.currentRow !== null) {
      // Substitui a row antiga pela editada
      Util.replaceItem(row, this.rowsValeTransporte, (vt: any) => {
        return vt.__id === row.__id;
      });
    } else {
      this.rowsValeTransporte.push(row);
    }

    this.vtGrid.showPopup = false;
  }

  private addVT() {
    this.vtGrid.currentRow = null;
    this.vtGrid.showPopup = true;
  }

  private editVT(row: any) {
    this.vtGrid.currentRow = row;
    this.vtGrid.showPopup = true;
  }

  private onSaveFormacao(row: any) {
    if (this.formacaoGrid.currentRow !== null) {
      // Substitui a row antiga pela editada
      Util.replaceItem(row, this.rowsFormacao, (formacao: any) => {
        return formacao.__id === row.__id;
      });
    } else {
      this.rowsFormacao.push(row);
    }

    this.formacaoGrid.showPopup = false;
  }

  private addFormacao() {
    this.formacaoGrid.currentRow = null;
    this.formacaoGrid.showPopup = true;
  }

  private editFormacao(row: any) {
    this.formacaoGrid.currentRow = row;
    this.formacaoGrid.showPopup = true;
  }

  private onSaveBeneficio(row: any) {
    if (this.beneficioGrid.currentRow !== null) {
      // Substitui a row antiga pela editada
      Util.replaceItem(row, this.rowsBeneficios, (ben: any) => {
        return ben.__id === row.__id;
      });
    } else {
      this.rowsBeneficios.push(row);
    }

    this.beneficioGrid.showPopup = false;
  }

  private addBeneficio() {
    this.beneficioGrid.currentRow = null;
    this.beneficioGrid.showPopup = true;
  }

  private editBeneficio(row: any) {
    this.beneficioGrid.currentRow = row;
    this.beneficioGrid.showPopup = true;
  }



  private loadVinculoFieldsData() {
    this.loadTiposVinculo();
    this.loadTiposAdmissao();
    this.loadVinculosEmpregaticios();
    this.loadCargos();
    this.loadTiposOcupacao();
    this.loadEscalas();
    this.loadEstruturasLegais();
    this.loadEstruturasGerenciais();
    this.loadEstruturasSindicais();
    this.loadEstruturasAdicionais();
    this.loadTiposSalario();
    this.loadModalidadesSalario();
    this.loadMotivosAdmissao();
    this.loadTodosVinculos();
    this.loadTiposTransferencia();
    this.loadSolicitacoesAdmissao();
  }

  private async loadTiposVinculo() {
    this.dadosVinculosFieldsData.tiposVinculo = await AdmissaoController.getTipoVinculo();
  }

  private async loadTiposAdmissao() {
    this.dadosVinculosFieldsData.tiposAdmissao = await AdmissaoController.getTipoAdmissao();
  }

  private async loadVinculosEmpregaticios() {
    this.dadosVinculosFieldsData.vinculosEmpregaticios = await AdmissaoController.getVinculoEmpregaticio();
  }

  private async loadCargos() {
    this.dadosVinculosFieldsData.cargos = await AdmissaoController.getOcupacao();
  }

  private async loadTiposOcupacao() {
    this.dadosVinculosFieldsData.tiposOcupacao = await AdmissaoController.getTipoOcupacao();
  }

  private async loadMotivosAdmissao() {
    this.dadosVinculosFieldsData.motivosAdmissao = await AdmissaoController.getMotivosAdmissao();
  }

  private async loadTodosVinculos() {
    this.dadosVinculosFieldsData.vinculos = await AdmissaoController.getTodosVinculos();
  }

  private async loadEscalas() {
    this.dadosVinculosFieldsData.escalas = await NovaSolicitacaoController.getEscalasTrab();
  }

  private async loadTurnos() {
    const nrEscala: string = this.rowsDadosVinculo.escala.NRESCALATRABM;
    this.dadosVinculosFieldsData.turnos = await NovaSolicitacaoController.getTurnos(nrEscala);
  }

  private async loadEstruturasLegais() {
    this.dadosVinculosFieldsData.estruturasLegais = await NovaSolicitacaoController.getEstruturas(
      'LEGAL'
    );
  }

  private async loadEstruturasGerenciais() {
    this.dadosVinculosFieldsData.estruturasGerenciais = await NovaSolicitacaoController.getEstruturas(
      'GERENCIAL'
    );
  }

  private async loadEstruturasSindicais() {
    this.dadosVinculosFieldsData.estruturasSindicais = await NovaSolicitacaoController.getEstruturas(
      'SINDICAL'
    );
  }

  private async loadEstruturasAdicionais() {
    this.dadosVinculosFieldsData.estruturasAdicionais = await NovaSolicitacaoController.getEstruturaAdicionalByTipo();
  }

  private async loadTiposSalario() {
    this.dadosVinculosFieldsData.tiposSalario = await AdmissaoController.getTipoSalario();
  }

  private async loadModalidadesSalario() {
    this.dadosVinculosFieldsData.modalidadesSalario = await NovaSolicitacaoController.getModalidadeSalarial();
  }

  private async loadTiposTransferencia() {
    this.dadosVinculosFieldsData.tipoTransferencia = await AdmissaoController.getTiposTransferencia();
  }

  private async loadSolicitacoesAdmissao() {
    this.solicitacoesAdmissao = await SolicitacaoController.getSolicitacoesAdmissao();

    const nrSolicitacaoRow = this.rowsDadosPessoais.documentos.NRSOLICITACAO;
    if(!nrSolicitacaoRow) return;

    const solicitacao = this.solicitacoesAdmissao.find((soli) => soli.NRSOLICITACAO == nrSolicitacaoRow);
    if(!solicitacao) return;

    this.rowsDadosPessoais.documentos.solicitacao = { isSolicitacao: true, NRPROCESSO: solicitacao.NRPROCESSO };
  }

  private async getTurnoParOuImpar() {
    const nrEscala = this.rowsDadosVinculo.escala.NRESCALATRABM;
    const number = this.rowsDadosVinculo.escala.CDTIPODIATRABALHO === 'I' ? 0 : 1;
    const diaReferencia = this.rowsDadosVinculo.escala.DTINIESCALA;

    if(!nrEscala || !this.isEscala12x36 || !diaReferencia) return;

    const turno = await EscalaController.getTurnoParOuImpar(nrEscala, number, diaReferencia);

    this.rowsDadosVinculo.escala = { ...this.rowsDadosVinculo.escala, NRTURNO: turno.NRTURNO };

  }

  private async escalaOnInput(nrEscala: string) {
    this.rowsDadosVinculo.escala.NRTURNO = null;
    if(!nrEscala) this.isEscala12x36 = false;

    const escala = this.dadosVinculosFieldsData.escalas.find((escala) => escala.NRESCALATRABM === nrEscala);

    this.isEscala12x36 = escala.NRTPJORNADA == '2';

    if (nrEscala) {
      await Promise.all([
        this.loadTurnos(),
        this.isEscala12x36 ? this.getTurnoParOuImpar() : null,
      ]);
      this.fillTurnoField();
    }
  }

  private fillTurnoField() {
    if (this.dadosVinculosFieldsData.turnos.length === 1) {
      const nrTurno: string = this.dadosVinculosFieldsData.turnos[0].NRTURNO;
      this.rowsDadosVinculo.escala.NRTURNO = nrTurno;
    }
  }

  private async comEmailOperadorOnInput(comOperador: string) {
    this.comOperador = comOperador == 'S' ? true : false;
  }

  private maeOnInput(value: string) {
    this.setRowFiliacao(value, true);
  }

  private paiOnInput(value: string) {
    this.setRowFiliacao(value, false);
  }

  private setRowFiliacao(
    name: string,
    mae: boolean,
  ) {
    const nrTipoRelacionamento = mae ?
      '1' :
      '2';

    const dependenteRow = this.rowsDependentes.find((rowDep: any) => {
      return rowDep.NRTIPORELACIONA === nrTipoRelacionamento;
    });

    if (dependenteRow) {
      if (name) {
        dependenteRow.NMPESSOA = name;
      } else {
        Util.arrayRemove(this.rowsDependentes, dependenteRow);
      }
    } else if (name) {
      const newRow: any = {
        NMPESSOA: name,
        NRTIPORELACIONA: nrTipoRelacionamento,
      };

      if (mae) {
        newRow.IDSEXOPESSOA = 'F';
        newRow.DSSEXOPESSOA = 'Feminino';
        newRow.NMTIPORELACIONA = 'Mae';
      } else {
        newRow.IDSEXOPESSOA = 'M';
        newRow.DSSEXOPESSOA = 'Masculino';
        newRow.NMTIPORELACIONA = 'Pai';
      }

      this.rowsDependentes.push(newRow);
    }
  }

  private cepOnInput() {
    this.fillByCEP();
  }

  private async fillByCEP() {
    const cep: string = this.rowEndereco.NRCEPENDERECO;
    const cepIsValid = DocumentoUtil.cepIsValid(cep);

    if (!cepIsValid) {
      return;
    }

    this.fillDirectlyByCep(cep);
  }

  private async fillDirectlyByCep(cep: string) {
    if (!cep) {
      return;
    }

    const cepInfo = await AdmissaoController.pesquisarCep(cep);

    this.fillPais();
    await this.fillEstado(cepInfo);
    await this.fillMunicipio(cepInfo);
    this.fillBairro(cepInfo);
    this.fillLogradouro(cepInfo);
    this.fillEndereco(cepInfo);
  }

  private fillPais(): boolean {
    this.rowEndereco.CDPAIS = '0055';

    return true;
  }

  private async fillEstado(
    cepInfo: any
  ) {
    const uf: string = cepInfo.uf;

    await this.loadEnderecoEstados();

    if (uf) {
      const estado = this.enderecoFieldsData.estados.find((estado: any) => {
        return estado.SGESTADO === uf;
      });

      if (estado) {
        this.rowEndereco.SGESTADO = estado.SGESTADO;

        return true;
      }
    }

    this.rowEndereco.SGESTADO = null;

    return false;
  }

  private async fillMunicipio(
    cepInfo: any
  ) {
    const cidadeCodigoIBGE: string = cepInfo.ibge;

    if (cidadeCodigoIBGE && this.rowEndereco.SGESTADO) {
      await this.loadEnderecoMunicipios();

      const cidade = this.enderecoFieldsData.municipios.find((municipio: any) => {
        return municipio.CDMUNICIBGE === cidadeCodigoIBGE;
      });

      if (cidade) {
        this.rowEndereco.CDMUNICIPIO = cidade.CDMUNICIPIO;

        return true;
      }
    }

    this.rowEndereco.CDMUNICIPIO = null;

    return false;
  }

  private fillBairro(
    cepInfo: any
  ): boolean {
    const bairro = cepInfo.bairro;

    if (bairro) {
      this.rowEndereco.NMBAIRROENDERECO = bairro;

      return true;
    }

    this.rowEndereco.NMBAIRROENDERECO = null;

    return false;
  }

  private fillEndereco(
    cepInfo: any,
  ): boolean {
    const endereco: string = cepInfo.logradouro;

    if (endereco) {
      this.rowEndereco.DSENDERECO = endereco;

      return true;
    }

    this.rowEndereco.DSENDERECO = null;

    return false;
  }

  private fillLogradouro(
    cepInfo: any,
  ): boolean {
    const endereco: string = cepInfo.logradouro;

    if (endereco) {
      const logradouro = this.enderecoFieldsData.logradouros.find((logra: any) => {
        const includes = endereco.includes(logra.DSLOGRADOURO);
        return includes;
      });

      if (logradouro) {
        this.rowEndereco.CDLOGRADOURO = logradouro.CDLOGRADOURO;

        return true;
      }
    }

    this.rowEndereco.CDLOGRADOURO = null;

    return false;
  }

  private tipoDepIsSet(
    dep: any
  ): boolean {
    const tipoDepIsSet =
      dep.NRTIPODEPENDE !== null &&
      dep.NRTIPODEPENDE !== undefined;

    return tipoDepIsSet;
  }

  private getDependenteTooltip(
    dep: any,
  ): string {
    const tipoDepIsSet = this.tipoDepIsSet(dep);

    const tooltip = tipoDepIsSet ?
      '' :
      'Existem campos obrigatórios não preenchidos!';

    return tooltip;
  }

  private getDependenteIcon(
    dep: any,
  ): string {
    const tipoDepIsSet = this.tipoDepIsSet(dep);

    const icon = tipoDepIsSet ?
      undefined :
      'mdi-alert';

    return icon;
  }

  private dtAdmissaoOnInput(value: string) {
    if (!value) {
      return;
    }

    this.rowsDadosVinculo.vinculo.DTBASEFERIAS = value;

    this.rowsDadosVinculo.vinculo.DTEXAMEMEDICO = value;

    this.rowsDadosVinculo.ocupacao.DTINIOCUPACAO = value;

    this.rowsDadosVinculo.escala.DTINIESCALA = value;

    this.validarDtAdmissao(false);
  }

  private diasExpOnInput() {
    const diasExp: number = this.rowsDadosVinculo.vinculo.NRDIASCONTRATOEXP;
    const dtAdmissao: string = this.rowsDadosVinculo.vinculo.DTADMISSAOVINC;

    if (Util.isUndefinedOrNull(diasExp) || Util.isUndefinedOrNull(dtAdmissao)) {
      return;
    }

    if (diasExp <= 0) {
      this.rowsDadosVinculo.vinculo.DTVENCCONTREXPER = null;
      return;
    }

    const dtVencContrato = DateUtil.addDaysDate(dtAdmissao, diasExp - 1);

    this.rowsDadosVinculo.vinculo.DTVENCCONTREXPER = dtVencContrato;
  }

  private dtVencContratoOnInput() {
    const dtVencContrato: string = this.rowsDadosVinculo.vinculo.DTVENCCONTREXPER;
    const dtAdmissao: string = this.rowsDadosVinculo.vinculo.DTADMISSAOVINC;

    if (Util.isUndefinedOrNull(dtVencContrato) || Util.isUndefinedOrNull(dtAdmissao)) {
      return;
    }

    const diasExp = DateUtil.differenceInDays(dtVencContrato, dtAdmissao) + 1;

    this.rowsDadosVinculo.vinculo.NRDIASCONTRATOEXP = diasExp;
  }

  private diasProrrOnInput() {
    const diasProrr: number = this.rowsDadosVinculo.vinculo.NRDIASCONTRATOEXPPRO;
    const dtVencContrato: string = this.rowsDadosVinculo.vinculo.DTVENCCONTREXPER;

    if (Util.isUndefinedOrNull(diasProrr) || Util.isUndefinedOrNull(dtVencContrato)) {
      return;
    }

    if (diasProrr <= 0) {
      this.rowsDadosVinculo.vinculo.DTFIMCONTRDETERMIN = null;
      return;
    }

    const dtFimContrato = DateUtil.addDaysDate(dtVencContrato, diasProrr - 1);

    this.rowsDadosVinculo.vinculo.DTFIMCONTRDETERMIN = dtFimContrato;
  }

  private dtFimContratoOnInput() {
    const dtFimContrato = this.rowsDadosVinculo.vinculo.DTFIMCONTRDETERMIN;
    const dtVencContrato: string = this.rowsDadosVinculo.vinculo.DTVENCCONTREXPER;

    if (Util.isUndefinedOrNull(dtFimContrato) || Util.isUndefinedOrNull(dtVencContrato)) {
      return;
    }

    const diasProrr = DateUtil.differenceInDays(dtFimContrato, dtVencContrato) + 1;

    this.rowsDadosVinculo.vinculo.NRDIASCONTRATOEXPPRO = diasProrr;
  }

  private motivoAdmissaoOnInput(value: string): void {
    if (Util.isUndefinedOrNull(value)) {
      this.rowsDadosVinculo.vinculo.NRVINCULOMSUBST = null;
    }
  }

  private async handleRedirectSolicitacaoAdmissao() {
    const solicitacao = store.getters.solicitacao;
    if(!solicitacao || !solicitacao.NRSOLICITACAO) return;

    this.rowsDadosPessoais.documentos.NRSOLICITACAO = solicitacao.NRSOLICITACAO;
    await this.handleTypeSolicitacaoAdmissao(solicitacao);
  }

  private async solicitacaoOnInput() {
    try {
      const nrSolicitacaoRow = this.rowsDadosPessoais.documentos.NRSOLICITACAO;
      const solicitacao = this.solicitacoesAdmissao.find((soli) => soli.NRSOLICITACAO == nrSolicitacaoRow);
  
      if(!solicitacao) {
        this.isSalarioReadOnly = false;
        this.isSoliSubstituicao = false;
        return;
      }
  
      this.rowsDadosPessoais.documentos.solicitacao = { isSolicitacao: true, NRPROCESSO: solicitacao.NRPROCESSO };
  
      await this.handleTypeSolicitacaoAdmissao(solicitacao); 
    } catch (error) {
      this.isSalarioReadOnly = false;
      this.isSoliSubstituicao = false;
    }
  }

  private async handleTypeSolicitacaoAdmissao(solicitacao: { NRSOLICITACAO: string, NRTIPOSOLICITACAO: string, NRVINCULOM: number, }) {
    if(solicitacao.NRTIPOSOLICITACAO == TiposSolicitacao.TP_SOLI_AUMENTO_QUADRO) {
      await this.handleSolicitacaoAumentoQuadro(solicitacao);
      this.isSoliSubstituicao = false;
      return;
    }

    if(solicitacao.NRTIPOSOLICITACAO == TiposSolicitacao.TP_SOLI_SUBSTITUICAO) {
      await this.handleSolicitacaoSubstituicao(solicitacao);
      this.isSoliSubstituicao = true;
      return;
    }
  }
  
  private getValorItensSolicitacao(itens: { DSCHAVEITEMSOLI: string, DSVALORITEMSOLI: string }[], chaves: string[]): { [key: string]: string | null } | undefined {
    if (!itens || !itens.length || !chaves || !chaves.length) return;
  
    const result: { [key: string]: string | null } = {};
  
    chaves.forEach(chave => {
      const item = itens.find(item => item.DSCHAVEITEMSOLI === chave);
      const value = item ? item.DSVALORITEMSOLI : null;
      result[chave] = value;
    });
    
    return result;
  }
  
  /**
 * Define os valores dos itens de solicitação nas linhas correspondentes.
 * @param {Object} valoresItens - Valores dos itens de solicitação.
 * @param {Array} chaves - Chaves dos itens de solicitação.
 * @param {Object} campos - Mapeamento de chaves para campos.
 */
private setValorItensSolicitacaoRow(valoresItens, chaves, campos) {
  // Verifica se valoresItens é um objeto
  if (typeof valoresItens !== 'object') return;

  chaves.forEach(chave => {
    const valorItem = valoresItens[chave];
    const campo = campos[chave];

    // Verifica se o valor do item e o campo existem antes de prosseguir
    if (valorItem && campo) {
      // Obtém o valor do item com ou sem descrição
      const valor = valorItem.split(' - ')[0];
      // Atualiza o campo target com o valor correspondente
      campo.target[campo.fieldName] = { ...campo.target[campo.fieldName], [chave]: valor };
    }
  });
}

/**
 * Manipula a solicitação de aumento de quadro.
 * @param {Object} dados - Dados da solicitação.
 * @param {string} dados.NRSOLICITACAO - Número da solicitação.
 */
  private async handleSolicitacaoAumentoQuadro({ NRSOLICITACAO }: { NRSOLICITACAO: string }) {
    const itensSolicitacao = await SolicitacaoController.getItemSolicitacao(NRSOLICITACAO);

    // As chaves e campos devem estar na mesma ordem.
    const chavesSolicitacao = ['NRCPFPESSOA', 'NMPESSOA', 'NRGRAUINSTR', 'VRSALARIO', 'NRESCALATRABM', 'NROCUPACAOM', 'NRTIPOVINCULOM', 'NRVINCULOEMPREG', 'NRESTRUTGEREN' , 'DTPREVISTAADMISSAO'];
    const items = this.getValorItensSolicitacao(itensSolicitacao, chavesSolicitacao);
    const { NRCPFPESSOA, VRSALARIO, NRESCALATRABM, DTPREVISTAADMISSAO } = items;

    const campos = {
      NRGRAUINSTR: { target: this.rowsDadosPessoais, fieldName: 'pessoa' },
      NMPESSOA: { target: this.rowsDadosPessoais, fieldName: 'pessoa' },
      VRSALARIO: { target: this.rowsDadosVinculo, fieldName: 'salario' },
      NRESCALATRABM: { target: this.rowsDadosVinculo, fieldName: 'escala' },
      NROCUPACAOM: { target: this.rowsDadosVinculo, fieldName: 'ocupacao' },
      NRTIPOVINCULOM: { target: this.rowsDadosVinculo, fieldName: 'vinculo' },
      NRVINCULOEMPREG: { target: this.rowsDadosVinculo, fieldName: 'vinculo' },
      NRESTRUTGEREN: { target: this.rowsDadosVinculo, fieldName: 'empresa' },
    };


    this.setValorItensSolicitacaoRow(items, chavesSolicitacao, campos);

    this.isSalarioReadOnly = VRSALARIO ? true : false;

    this.rowsDadosVinculo.vinculo = { ...this.rowsDadosVinculo.vinculo, DTADMISSAOVINC: DTPREVISTAADMISSAO }
    this.dtAdmissaoOnInput(DTPREVISTAADMISSAO);

    if(NRESCALATRABM) this.loadTurnos();

    if(NRCPFPESSOA) await this.getDadosCpf(NRCPFPESSOA);

    this.rowsDadosPessoais.documentos = { ...this.rowsDadosPessoais.documentos, NRCPFPESSOA };
  }

  /**
 * Manipula a solicitação de substituição.
 * @param {Object} dados - Dados da solicitação.
 * @param {string} dados.NRSOLICITACAO - Número da solicitação.
 * @param {string} dados.NRVINCULOM - Número do Vínculo.
 */
  private async handleSolicitacaoSubstituicao({ NRSOLICITACAO, NRVINCULOM }: { NRSOLICITACAO: string, NRVINCULOM: number }) {
    const [ itensSolicitacao, dadosVinculo ] = await Promise.all([
      SolicitacaoController.getItemSolicitacao(NRSOLICITACAO),
      SolicitacaoController.getDadosVinculo(NRVINCULOM)
    ]);

    this.setDadosVinculoSubstituido(dadosVinculo);

    this.rowsDadosVinculo.vinculo.NRVINCULOMSUBST = NRVINCULOM;

    // As chaves e os campos devem estar na mesma ordem.
    const chavesSolicitacao = ['NRCPFPESSOA', 'NMPESSOA', 'VRSALARIO', 'NRESCALATRABM', 'NROCUPACAOM', 'NRTIPOVINCULOM', 'NRVINCULOEMPREG', 'NRESTRUTGEREN', 'NRMOTIVOADMISSAO', 'DTADMISSAOVINC', 'DTPREVISTAADMISSAO'];
    const items = this.getValorItensSolicitacao(itensSolicitacao, chavesSolicitacao);
    const { NRCPFPESSOA, VRSALARIO, NRESCALATRABM, DTPREVISTAADMISSAO } = items;

    const campos = {
      NRCPFPESSOA: { target: this.rowsDadosPessoais, fieldName: 'documentos' },
      NMPESSOA: { target: this.rowsDadosPessoais, fieldName: 'pessoa' },
      VRSALARIO: { target: this.rowsDadosVinculo, fieldName: 'salario' },
      NRESCALATRABM: { target: this.rowsDadosVinculo, fieldName: 'escala' },
      NROCUPACAOM: { target: this.rowsDadosVinculo, fieldName: 'ocupacao' },
      NRTIPOVINCULOM: { target: this.rowsDadosVinculo, fieldName: 'vinculo' },
      NRVINCULOEMPREG: { target: this.rowsDadosVinculo, fieldName: 'vinculo' },
      NRESTRUTGEREN: { target: this.rowsDadosVinculo, fieldName: 'empresa' },
      NRMOTIVOADMISSAO: { target: this.rowsDadosVinculo, fieldName: 'vinculo' },
    };

    this.setValorItensSolicitacaoRow(items, chavesSolicitacao, campos);

    this.isSalarioReadOnly = VRSALARIO ? true : false;
    this.rowsDadosVinculo.vinculo = { ...this.rowsDadosVinculo.vinculo, DTADMISSAOVINC: DTPREVISTAADMISSAO }
    this.dtAdmissaoOnInput(DTPREVISTAADMISSAO);

    if(NRESCALATRABM) this.loadTurnos();

    if(NRCPFPESSOA) await this.getDadosCpf(NRCPFPESSOA);
  }

  private async verificaVinculoExistente() {
    if(!Util.isEmptyOrBlank(this.vinculoCpf)) {
      const callbackRejectCpf = () => this.rowsDadosPessoais.documentos.NRCPFPESSOA = null;
      
      if(!this.vinculoCpf || this.vinculoCpf.IDDESLGOURESCD != 'S') return;
      
      const dtAdmissao = this.vinculoCpf.DTADMISSAOVINC && this.vinculoCpf.DTADMISSAOVINC.split(' ')[0];
      const dtRescisao = this.vinculoCpf.DTRESCISAOVINC && this.vinculoCpf.DTRESCISAOVINC.split(' ')[0];

      const nmVinculom = this.vinculoCpf.NMVINCULOM || 'Indefinido';
      const nrVinculom = this.vinculoCpf.NRVINCULOM || 'Indefinido';

      const obs = this.vinculoCpf.DSOBSERVACAORESCISAO || '';
      const isDp = this.user.dp;

      if(this.vinculoCpf.IDVERIFICARESCISAO == 'S') {
        await DialogUtils.show(
          'Alerta', `O candidato ${nmVinculom}, já foi empregado da respectiva empresa, e foi indicado como "Pessoa não Grata". Logo, não poderá ser admitido. Observação: ${obs}`,
          () => {},
          callbackRejectCpf,
          false,
          !isDp
        );

        return;
      }

      await DialogUtils.show(
        'Alerta', `Pessoa já possuiu vínculo empregatício na respectiva organização. Vínculo: ${nrVinculom} – ${nmVinculom}
        data de admissão ${dtAdmissao || 'não definida'} data de rescisão ${dtRescisao || 'não definida'}`,
        () => {},
        callbackRejectCpf
      );
    }
  }

  private verificaSolicitacaoSubstituicaoVinculo() {
    const nrVinculoSubst = this.rowsDadosVinculo.vinculo.NRVINCULOMSUBST;

    if(!nrVinculoSubst) return true;

    const vinculoSubstituido = this.dadosVinculosFieldsData.vinculos.find((vinculo) => vinculo.NRVINCULOMSUBST == nrVinculoSubst);

    if(vinculoSubstituido) {
      const message = `O "vínculo substituído" selecionado já foi substituído. Favor Verificar com RH`;
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
      return false;
    }

    return true;
  }

  private async setDadosVinculoSubstituido(dados: DadosVinculo) {
    if(!dados) return;

    const { NRTIPOVINCULOM, NRTPADMISSAO, NRVINCULOEMPREG, IDTPPAGAMENTO, IDREMUNERACAO, IDMULTVINC, 
      IDCONTRIBUISIND, NRCARGO, NRTIPOOCUPACAO, NRESTRUTLEGAL, NRESTRUTGEREN, 
      NRESTRUTSIND, VRSALARIO, IDTPSALARIO, NRTPMODALIDSAL, 
      NRESCALATRABM, NRTURNO } = dados; 

    // Vínculo
    this.rowsDadosVinculo.vinculo = { ...this.rowsDadosVinculo.vinculo, NRTIPOVINCULOM,  NRTPADMISSAO, NRVINCULOEMPREG, IDTPPAGAMENTO, IDREMUNERACAO, IDMULTVINC,IDCONTRIBUISIND };

    // Ocupação
    this.rowsDadosVinculo.ocupacao = { ...this.rowsDadosVinculo.ocupacao, NROCUPACAOM: NRCARGO, NRTIPOOCUPACAO }

    // Empresa
    this.rowsDadosVinculo.empresa = { ...this.rowsDadosVinculo.empresa, NRESTRUTLEGAL, NRESTRUTGEREN, NRESTRUTSIND }

    // Salário
    const salario = (VRSALARIO && String(VRSALARIO).replace('.', ',')) || null;
    this.rowsDadosVinculo.salario = { ...this.rowsDadosVinculo.salario, VRSALARIO: salario, IDTPSALARIO, NROCORRENCIA: 1, NRTPMODALIDSAL }
    
    // Escala
    this.rowsDadosVinculo.escala = { ...this.rowsDadosVinculo.escala, NRESCALATRABM, NRTURNO };

    if(NRESCALATRABM) this.loadTurnos();
  }

  private async validationEstrutGerenELegal() {
    const hierarquia = await SolicitacaoController.getHierarquiaByEstruturaLegalAndGeren(this.rowsDadosVinculo.empresa.NRESTRUTLEGAL, this.rowsDadosVinculo.empresa.NRESTRUTGEREN)

    if(hierarquia && !hierarquia.length) {
      await DialogUtils.show('Aviso', Messages.SOLIC_ESTRUTGEREN_NOT_RELAC_ESTRUTLEGAL, () => {}, () => {}, false, true);
      return false;
    } 
  
    return true;
  }

  // #endregion
}

export default NovaAdmissaoPopup;
